const fr = {
  "nav.home": "Accueil",
  "nav.browse": "Parcourir les offres",
  "nav.nearExpiry": "Bientôt expiré",
  "nav.categories": "Catégories",
  "nav.businesses": "Commerces",
  "nav.favourites": "Favoris",
  "nav.following": "Abonnements",
  "follows.title": "Abonnements",
  "follows.subtitle": "Tous les commerces et lieux que vous suivez, au même endroit. On vous prévient dès qu'il y a du nouveau.",
  "follows.businesses": "Commerces suivis ({n})",
  "follows.places": "Lieux suivis ({n})",
  "follows.followPlace": "Suivre ce lieu",
  "follows.following": "Suivi",
  "follows.nowFollowing": "Vous suivez {name}",
  "follows.unfollowed": "Vous ne suivez plus {name}",
  "follows.placeNudge": "On vous prévient dès qu'un commerce d'ici publie une offre.",
  "follows.signIn": "Connectez-vous pour suivre des commerces et des lieux",
  "follows.createAccount": "Créer un compte gratuit",
  "follows.emptyTitle": "Vous ne suivez encore personne",
  "follows.emptyBody": "Suivez un commerce ou une galerie et les nouvelles offres viendront à vous.",
  "nav.myDeals": "Mes offres",
  "nav.lytemap": "LyteMap",
  "nav.postDeal": "Publier une offre",
  "nav.analytics": "Statistiques",
  "nav.admin": "Admin",
  "nav.ourStory": "Notre histoire",
  "nav.myAccount": "Mon compte",
  "nav.pricing": "Tarifs",

  "brand.tagline": "Économisez plus. Gaspillez moins.",

  "sidebar.businessLogin": "Connexion",
  "sidebar.signupFree": "Nouveau ici ? Inscription gratuite",
  "sidebar.proActive": "Pro actif",
  "sidebar.until": "Jusqu'au {date}",
  "sidebar.growPro": "Développez avec Pro",
  "sidebar.growProDesc": "Mise en avant, offres illimitées et statistiques complètes.",
  "sidebar.goPremium": "Passer Premium",

  "topbar.searchPlaceholder": "Rechercher des offres, commerces ou catégories...",
  "topbar.aiPlaceholder": "Demandez à l'IA : dîner pas cher près d'ici…",
  "topbar.askAi": "Demander à l'IA",
  "topbar.nearMe": "Près de moi",
  "topbar.anywhere": "Partout",
  "topbar.country": "Pays",
  "topbar.city": "Ville",
  "topbar.allCities": "Toutes les villes",
  "topbar.useMyLocation": "Utiliser ma position",
  "topbar.privacyNote": "Nous utilisons la position de votre appareil, pas votre adresse IP — c'est privé et précis même avec un VPN.",
  "topbar.typePlace": "ou saisissez une ville ou un lieu…",
  "topbar.clearEverywhere": "Effacer — voir les offres partout",
  "topbar.notifications": "Notifications",
  "topbar.more": "Plus d'options",
  "topbar.darkMode": "Mode sombre",
  "topbar.lightMode": "Mode clair",
  "topbar.recent": "{n} récentes",
  "topbar.noNotifs": "Aucune notification pour l'instant.",
  "topbar.viewAllDeals": "Voir toutes les offres",
  "topbar.hello": "Bonjour, {name}",
  "topbar.login": "Connexion",
  "topbar.try": "Essayez :",

  "footer.contact": "Contact",
  "footer.terms": "Conditions d'utilisation",
  "footer.privacy": "Politique de confidentialité",
  "footer.pricing": "Tarifs",
  "footer.refunds": "Politique de remboursement",

  "home.todaysBest": "Les meilleures offres du jour",
  "home.upToOff": "Jusqu'à {n}% de réduction",
  "home.explore": "Explorer les offres",
  "home.browseCategories": "Parcourir les catégories",
  "home.eduHeroA": "Apprenez pour",
  "home.eduHeroB": "moins.",
  "home.eduHeroSub": "Trouvez des cours particuliers, formations et classes près de chez vous, à petit prix.",
  "home.liveDeals": "{n} offres en cours",
  "home.categoriesCount": "{n} catégories",
  "home.shopByCategory": "Acheter par catégorie",
  "home.viewAll": "Voir tout",
  "home.featuredDeals": "⭐ Offres à la une",
  "home.featuredNearYou": "⭐ À la une",
  "home.featuredIn": "⭐ À la une à {place}",
  "home.topDeals": "Meilleures offres",
  "home.topDealsNear": "Meilleures offres près de {place}",
  "home.topDealsNearYou": "Meilleures offres près de vous",
  "home.locPromptTitle": "Voyez les offres autour de vous",
  "home.locPromptDesc": "Partagez votre position et nous placerons les offres les plus proches — avec les distances — en haut de votre page.",
  "home.shareLocation": "Partager ma position",
  "home.locating": "Localisation…",

  "tourist.visitingTitle": "De passage dans la région ?",
  "tourist.visitingDesc": "Activez le Mode Touriste pour voir les meilleures offres près de vous, dans votre devise, avec itinéraire en un clic.",
  "tourist.imVisiting": "Je suis de passage",

  "rail.yourLocation": "Votre position",
  "rail.change": "Modifier",
  "rail.featuredDeal": "Offre à la une",
  "rail.viewDeal": "Voir l'offre",
  "rail.nearExpiry": "Bientôt expiré",
  "rail.lastChance": "(Dernière chance !)",
  "rail.viewAll": "Voir tout",
  "rail.noNearExpiry": "Aucun article bientôt expiré pour le moment.",
  "rail.getAlerts": "Recevoir les alertes d'offres",
  "rail.getAlertsDesc": "Soyez le premier informé des nouvelles offres et ventes flash !",
  "rail.enableAlerts": "Activer les alertes",

  "lang.label": "Langue",

  "cat.All": "Tout",
  "cat.Food": "Alimentation",
  "cat.Drinks": "Boissons",
  "cat.Health": "Santé",
  "cat.Events": "Événements",
  "cat.Lodging": "Hébergement",
  "cat.Services": "Services",
  "cat.Pets": "Animaux",
  "cat.Beauty": "Beauté",
  "cat.Tech": "Tech",
  "cat.Near Expiry": "Bientôt expiré",
  "cat.Upcoming": "À venir",
  "cat.Automotive": "Auto",
  "cat.Fitness": "Fitness",
  "cat.Clothing": "Vêtements",
  "cat.Plants": "Plantes",
  "cat.Education": "Éducation",
  "cat.Farm & Livestock": "Ferme & Élevage",
  "cat.Other": "Autres",
  "cat.More": "Plus",
  "time.expired": "Expirée",
  "time.dLeft": "{d}j {h}h restantes",
  "time.hLeft": "{h}h {m}min restantes",
  "time.mLeft": "{m}min {s}s restantes",
  "card.save": "Économisez {amount}",
  "card.review": "{n} avis",
  "card.reviews": "{n} avis",
  "map.dealsHere": "{n} offres ici",
  "map.dealsAtSpot": "{n} offres à cet endroit",
  "map.businessesHere": "{n} commerces",
  "map.endsSoon": "se termine bientôt",
  "map.viewDeal": "Voir l'offre",
  "map.directions": "Itinéraire",
  "map.branchOf": "1 sur {n} adresses",
  "map.approx": "{amount} environ",
  "map.subtitleGps": "Offres autour de {place} — cherchez un autre lieu dans la barre du haut pour déplacer la carte.",
  "map.subtitle": "Partagez votre position pour voir aussitôt les offres près de vous, ou cherchez une ville / choisissez un pays dans la barre du haut.",
  "map.yourLocation": "votre position",
  "map.jumpTo": "Aller à :",
  "map.autoDetected": "Offres à {country} — ce n'est pas ça ?",
  "map.change": "Changer",
  "map.maybeLaterBrowse": "Plus tard — parcourir {place}",
  "map.allDeals": "toutes les offres",
  "map.endingSoon": "Se terminent bientôt",
  "map.inView": "Dans la vue",
  "map.all": "Tout",
  "map.inViewCount": "{n} sur {m} dans la vue",
  "map.nearbyCount": "{n} sur {m} à proximité",
  "map.dealCount": "{n} offres",
  "map.dealCountNearby": "{n} offres à proximité",
  "map.fitAll": "Voir toutes les offres",
  "map.geoTitle": "Voir les offres près de vous",
  "map.geoDesc": "Partagez votre position et nous affichons aussitôt les meilleures offres autour de vous sur la carte.",
  "map.emptyFilter": "Aucune offre ne correspond à ce filtre ici.",
  "map.emptyGps": "Pas encore d'offres près de ce lieu — essayez un autre endroit ou explorez par pays.",
  "map.emptyCountry": "Pas encore d'offres à {country}.",
  "map.emptyInView": "Aucune offre dans cette partie de la carte.",
  "map.zoomOut": "Dézoomer pour voir les {n}",
  "map.myLocation": "Votre position",
  "map.expandMap": "Agrandir la carte",
  "map.showList": "Voir les offres",
  "map.openNow": "Ouvert maintenant",
  "map.openBadge": "Ouvert maintenant",
  "map.closedBadge": "Fermé actuellement",
  "map.heatmap": "Carte des remises",
  "map.heatLegend": "Les plus grosses remises du secteur",
  "map.shareView": "Partager cette vue",
  "map.shareTitle": "Offres sur LytePress",
  "map.linkCopied": "Lien copié — partagez-le où vous voulez",
  "map.sharedView": "Affichage d'une vue de carte partagée",
  "map.world": "Monde",
  "map.shopsHere": "{n} commerces",
  "map.sharedAddress": "{n} commerces à cette adresse",
  "spot.eyebrow": "Toutes les offres à cette adresse",
  "spot.fallbackTitle": "Cette adresse",
  "spot.dealCount": "{n} offres",
  "spot.visitShop": "Voir la boutique",
  "spot.seeAll": "Tout voir",
  "spot.backToMap": "Retour à LyteMap",
  "spot.gone": "Aucune offre active à cette adresse pour le moment.",
  "spot.share": "Partager ces offres",
  "spot.shareCopied": "Copié — collez-le où vous voulez",
  "spot.shareHead": "{name} — {shops} commerces, {deals} offres sur LytePress en ce moment :",
  "spot.shareMore": "…et {n} autres",
  "map.noDealsRegion": "Pas encore d'offres dans cette région.",
  "invite.cta": "Inviter un commerce",
  "invite.title": "Invitez un commerce sur LytePress",
  "invite.subtitle": "Vous connaissez une boutique avec de bonnes offres ? Dites-le nous et nous l'invitons.",
  "invite.namePh": "Nom du commerce",
  "invite.cityPh": "Ville",
  "invite.countryPh": "Pays",
  "invite.emailPh": "Son e-mail (facultatif)",
  "invite.notePh": "Pourquoi les acheteurs devraient la connaître ? (facultatif)",
  "invite.submit": "Envoyer l'invitation",
  "invite.privacy": "Ces informations servent uniquement à inviter le commerce. Aucun compte n'est créé.",
  "invite.sentEmail": "Invitation envoyée par e-mail",
  "invite.logged": "Merci, c'est noté !",
  "invite.nudge": "Un message personnel marche mieux. Envoyez-leur ceci :",
  "invite.shareMsg": "Bonjour {name} ! Publiez vos offres sur LytePress pour que les acheteurs du quartier vous trouvent — gratuit pour commencer : {url}",
  "invite.whatsapp": "Envoyer sur WhatsApp",
  "invite.copy": "Copier le message",
  "invite.failed": "Impossible d'envoyer cette invitation. Réessayez.",
  "map.citiesIn": "Villes en {country} :",
  "map.allOf": "Tout {country}",
  "map.moreCountries": "+{n} autres pays",
  "map.fewerCountries": "Afficher moins",
  "map.countriesIn": "Pays en {region} :",
  "reg.Caribbean": "Caraïbes",
  "reg.North America": "Amérique du Nord",
  "reg.Central America": "Amérique centrale",
  "reg.South America": "Amérique du Sud",
  "reg.Europe": "Europe",
  "reg.Middle East": "Moyen-Orient",
  "reg.Africa": "Afrique",
  "reg.Asia": "Asie",
  "reg.Oceania": "Océanie",
  "reg.Other": "Autres",
  "pd.postTitle": "Publier une offre",
  "pd.editTitle": "Modifier l'offre",
  "pd.dealTitle": "Titre de l'offre",
  "pd.dealTitlePh": "ex. 2 grandes pizzas pour 1",
  "pd.photos": "Photos de l'offre",
  "pd.photosHint": "(jusqu'à 6 - les acheteurs peuvent les faire défiler)",
  "pd.cover": "Couverture",
  "pd.category": "Catégorie",
  "pd.currency": "Devise",
  "pd.redeemHow": "Comment cette offre est-elle utilisée ?",
  "pd.inPerson": "Sur place",
  "pd.onlineOnly": "En ligne uniquement",
  "pd.onlineNote": "Aucun point sur la carte - les acheteurs du monde entier la verront",
  "pd.promoLabel": "Code promo à utiliser au paiement",
  "pd.promoHint": "Caché jusqu'à ce qu'un acheteur prenne l'offre, puis affiché avec un bouton de copie. Vérifiez qu'il fonctionne sur votre site.",
  "pd.whichLocations": "À quelles adresses cette offre s'applique-t-elle ?",
  "pd.pinLabel": "Placez l'offre sur la carte",
  "pd.description": "Description",
  "pd.descriptionPh": "Décrivez l'offre...",
  "pd.dealType": "Type d'offre",
  "pd.percentOff": "Pourcentage de remise (%)",
  "pd.setPrice": "Prix fixe",
  "pd.originalPrice": "Prix initial ({sym})",
  "pd.dealPrice": "Prix de l'offre ({sym})",
  "pd.discountPct": "Remise (%)",
  "pd.terms": "Conditions générales",
  "pd.endsOn": "Se termine le",
  "pd.lastChance": "Dernière chance",
  "pd.lastChanceNote": "est automatique - votre offre rejoint cette liste dès qu'il reste moins de 48 heures.",
  "pd.shortDated": "Produit à date proche",
  "pd.bestBefore": "À consommer avant le (facultatif)",
  "pd.feature": "Mettre cette offre en avant",
  "pd.timezone": "Fuseau horaire",
  "pd.publishAt": "Publier le",
  "pd.publishHint": "Laissez vide pour publier immédiatement.",
  "pd.publish": "Publier l'offre",
  "pd.saveChanges": "Enregistrer",
  "pd.promoNeeded": "Code promo requis",
  "pd.promoNeededMsg": "Les offres en ligne s'utilisent avec un code promo - ajoutez le code que les acheteurs doivent saisir.",
  "pd.addDiscount": "Ajoutez une remise",
  "pd.addDiscountMsg": "Indiquez le pourcentage de remise de cette offre (1-100).",
  "pd.subtitle": "Partagez une promotion ou une offre bientôt expirée avec votre communauté.",
  "pd.upload": "Touchez pour importer ou prendre des photos",
  "pd.uploadHint": "JPG, PNG ou WEBP, 8 Mo maximum chacune",
  "pd.branchHint": "Cochez pour inclure une adresse enregistrée. Vous pouvez aussi ajouter un point personnalisé sur la carte.",
  "picker.searchPh": "Cherchez une adresse ou un lieu...",
  "picker.find": "Chercher",
  "picker.gps": "Utiliser mon GPS",
  "picker.hint": "Cherchez, utilisez le GPS ou touchez la carte pour poser un point. Faites glisser le point pour ajuster l'endroit exact.",
  "picker.namedPre": "Nous avons nommé ce point",
  "picker.editName": "Pas correct ? Touchez pour modifier le nom vu par les acheteurs",
  "pd.editSubtitle": "Ajustez le prix, les dates ou les détails, puis publiez votre offre mise à jour.",
  "pd.uploading": "Envoi...",
  "pd.pinHint": "- ajoutez un point pour chaque adresse où l'offre est disponible. Les adresses viennent de votre profil commerce (une offre peut les remplacer ci-dessous).",
  "pd.codeReq": "Exiger un code d'utilisation en magasin",
  "pd.codeReqHint": "Les acheteurs reçoivent un code et un QR uniques à présenter en caisse. Vous le validez depuis Mon compte - vous savez exactement combien de clients LytePress vous a envoyés.",
  "pd.schedule": "Programmer la mise en ligne",
  "pd.scheduleHint": "Publication automatique à une heure précise dans le fuseau choisi. Laissez désactivé pour publier maintenant. L'expiration utilise la date Se termine le ci-dessus.",
  "pd.branchFooter": "Facultatif - si vous passez cette étape, nous placerons l'offre à l'adresse enregistrée de votre commerce ({place}). Gérez vos horaires dans",
  "pd.beating": "Vous devancez {rival}",
  "pd.beatingMsg": "Leur '{title}' est à -{rivalDiscount}% - nous avons préparé une offre plus forte à -{discount}%. Ajustez et publiez pour emporter le client.",
  "pd.termsDefault": "Valable jusqu'à épuisement des stocks. Non cumulable avec d'autres offres.",
  "common.percentOff": "{n}% de remise",
  "common.tryAgain": "Veuillez réessayer.",

  "browse.title": "Parcourir les offres",
  "browse.nearYou": "Offres près de vous",
  "browse.nearPlace": "Offres près de {place}",
  "browse.sortedFrom": "Classées par distance depuis {place}.",
  "browse.bestLocal": "Les meilleures économies locales à {place}.",
  "browse.worldwide": "De belles offres du monde entier.",
  "browse.radius": "Rayon de distance",
  "browse.openNow": "Ouvert maintenant",
  "browse.online": "En ligne",
  "browse.shortDated": "Date proche",
  "browse.clearSearch": "Effacer la recherche",
  "browse.aiNoMatch": "Aucune offre ne correspond à cette recherche. Reformulez — par exemple « offres restaurant à moins de 20 $ » ou « électronique près de moi ».",
  "browse.aiUnavailable": "La recherche IA est indisponible pour le moment — voici vos résultats habituels.",
  "browse.searchFilters": "Filtres de votre recherche :",
  "browse.noDeals": "Pas encore d'offres ici",
  "browse.noMatch": "Rien ne correspond à “{q}”. Essayez d'autres mots ou une autre catégorie.",
  "browse.closestMatches": "Pas de correspondance exacte pour “{q}” — voici les offres les plus proches.",
  "browse.didYouMean": "Rechercher “{q}” à la place",
  "trending.label": "Tendances près de vous",
  "saved.cta": "Enregistrer cette recherche",
  "saved.saved": "Recherche enregistrée",
  "saved.section": "Recherches enregistrées ({n})",
  "saved.done": "“{q}” enregistré",
  "saved.doneBody": "On vous prévient dès qu'une offre correspond.",
  "saved.removed": "“{q}” supprimé",
  "saved.signIn": "Connectez-vous pour enregistrer des recherches",
  "browse.browseCats": "Parcourir les catégories",
  "browse.emptyOpenNow": "Aucune offre de commerce ouvert en ce moment. Essayez de désactiver « Ouvert maintenant ».",
  "browse.emptyShortDated": "Aucun produit à date proche pour l'instant — revenez bientôt, ils apparaissent quand les commerces soldent des stocks proches de leur date.",
  "browse.emptyOnline": "Pas encore d'offres uniquement en ligne — désactivez le filtre En ligne pour voir les offres près de vous.",
  "browse.emptyRadius": "Aucune offre à moins de {radius} de vous. Essayez d'élargir le rayon.",
  "browse.emptyRadiusPlace": "Aucune offre à moins de {radius} de {place}. Essayez d'élargir le rayon.",
  "browse.emptyDefault": "Aucune offre ne correspond à vos filtres. Retirez un filtre ou explorez une autre catégorie.",
  "browse.firstBusiness": "Soyez le premier commerce à {place}",
  "browse.firstBusinessMsg": "Personne n'a encore publié ici — la première offre capte tous les acheteurs qui arrivent, et votre commerce reste seul en haut de la carte.",
  "browse.postFirst": "Publier la première offre",
  "browse.yourArea": "votre région",

  "card.lastChance": "Dernière chance",
  "card.shortDated": "Date proche",
  "card.online": "Offre en ligne",
  "card.directions": "Itinéraire",
  "card.favourite": "Ajouter aux favoris",
  "card.inYourCurrency": "dans votre devise",
  "card.locations": "{n} adresses",

  "fav.title": "Favoris",
  "fav.subtitle": "Les offres que vous avez gardées pour plus tard.",
  "fav.emptyTitle": "Aucun favori pour l'instant",
  "fav.emptyMsg": "Touchez le cœur sur une offre pour la garder ici.",
  "fav.browse": "Parcourir les offres",

  "cats.heading": "Que cherchez-vous ?",
  "cats.allDeals": "Toutes les offres",
  "cats.endingSoon": "Se terminent bientôt",

  "mydeals.guestTitle": "Vos offres récupérées sont ici",
  "mydeals.guestMsg": "Connectez-vous gratuitement et chaque offre récupérée — codes, pass QR et promos — est gardée ici sur tous vos appareils, avec des rappels avant la fin.",
  "mydeals.createAccount": "Créer un compte gratuit",
  "mydeals.businessTitle": "Mes offres est réservé aux acheteurs",
  "mydeals.businessMsg": "Gérez les offres que vous avez publiées depuis votre tableau de bord.",
  "mydeals.goDashboard": "Aller au tableau de bord",
  "mydeals.title": "Mes offres",
  "mydeals.subtitle": "Toutes les offres récupérées — présentez-les au commerce pour en profiter.",
  "mydeals.emptyTitle": "Aucune offre récupérée",
  "mydeals.emptyMsg": "Touchez « Prendre l'offre » sur n'importe quelle promo : elle apparaîtra ici avec votre code, un compte à rebours et l'itinéraire.",
  "mydeals.ready": "Prêtes à utiliser",
  "mydeals.nothingWaiting": "Rien en attente —",
  "mydeals.grabNew": "prenez une nouvelle offre",
  "mydeals.redeemedOn": "utilisée le {date}",
  "mydeals.youSavedAmount": "vous avez économisé {amount}",
  "mydeals.youSavedTotal": "Vous avez économisé {amount}",
  "mydeals.redeemed": "Utilisées",
  "mydeals.ended": "Terminées",
  "mydeals.dealEnded": "Cette offre est terminée",
  "mydeals.toRedeem": "{time} pour en profiter",
  "mydeals.noExpiry": "Sans date limite — utilisez-la quand vous voulez",
  "mydeals.showAtCheckout": "À présenter en caisse",
  "mydeals.useOnlineCode": "Utilisez votre code sur leur boutique en ligne",
  "mydeals.showAtBusiness": "Présentez cette offre chez {business}",
  "mydeals.shortDated": "Date proche",
  "mydeals.useBy": "à consommer avant le {date}",
  "mydeals.copy": "Copier",
  "mydeals.codeCopied": "Code copié",
  "mydeals.pasteAt": "Collez {code} au paiement.",
  "mydeals.yourCode": "Voici votre code",
  "mydeals.undone": "Offre annulée",
  "mydeals.undoneMsg": "« {title} » a été retirée de Mes offres.",
  "mydeals.undoFailed": "Annulation impossible",

  "nearexp.subtitle": "Prenez-les avant qu'elles disparaissent — économisez et réduisez le gaspillage.",
  "nearexp.grab": "Prendre l'offre",
  "nearexp.emptyTitle": "Rien n'expire pour l'instant",
  "nearexp.emptyMsg": "Aucune offre de dernière chance en ce moment. Revenez bientôt — elles apparaissent à l'approche de leur date de fin.",
  "nearexp.browseAll": "Voir toutes les offres",

  "deal.notFound": "Offre introuvable.",
  "deal.back": "Retour aux offres",
  "deal.featured": "À LA UNE",
  "deal.zoom": "Voir l'image en entier",
  "deal.zoomHint": "Pincez ou touchez deux fois pour zoomer",
  "deal.zoomReset": "Touchez deux fois pour réinitialiser",
  "deal.translate": "Traduire",
  "deal.translated": "Traduit",
  "deal.translateFail": "Traduction indisponible",
  "deal.inYourCurrency": "dans votre devise",
  "deal.shortDatedTitle": "Produit à date proche",
  "deal.shortDatedUseBy": "à consommer avant le {date}",
  "deal.shortDatedNote": "Parfaitement bon, au prix réduit pour qu'il soit consommé au lieu d'être jeté. Vérifiez que la date vous convient avant d'acheter.",
  "deal.onlineTitle": "Offre en ligne",
  "deal.onlineMsg": "Aucun déplacement nécessaire — prenez l'offre pour révéler votre code promo, puis utilisez-le sur la boutique en ligne de {business}.",
  "deal.onlineWorldwide": "Disponible pour les acheteurs partout dans le monde.",
  "deal.onlineBadge": "Offre en ligne · utilisable partout",
  "deal.grab": "Prendre l'offre",
  "deal.getCode": "Obtenir mon code",
  "deal.getPromo": "Obtenir mon code promo",
  "deal.signInGrab": "Connexion gratuite et prendre l'offre",
  "deal.grabbed": "Offre récupérée !",
  "deal.promoUse": "Utilisez ce code promo sur la boutique en ligne de {business} :",
  "deal.copyCode": "Copier le code",
  "deal.savedInPre": "Gardée dans",
  "deal.savedUntilExpiry": "jusqu'à son expiration.",
  "deal.visitToRedeem": "Rendez-vous chez {business} à {location} pour profiter de cette offre avant la fin.",
  "deal.loginHint": "Compte acheteur gratuit · 10 secondes · on vous ramène ici",
  "deal.signInToGrab": "Connectez-vous pour prendre cette offre",
  "deal.signInToGrabMsg": "Créez un compte acheteur gratuit — on vous ramène directement à cette offre.",
  "deal.couldNotGrab": "Impossible de prendre l'offre",
  "deal.codeCopied": "Code copié",
  "deal.pasteAt": "Collez {code} au paiement.",
  "deal.grabUndone": "Offre annulée",
  "deal.grabUndoneMsg": "Pas de souci — l'offre est toujours là si vous changez d'avis.",
  "deal.mapUnavailable": "Carte indisponible",
  "deal.location": "Adresse",
  "deal.availableAt": "Disponible dans {n} adresses",
  "deal.directions": "Itinéraire",
  "deal.terms": "Conditions",
  "deal.staffCode": "Le personnel de {business} saisira ce code pour appliquer votre remise. Usage unique — retrouvez-le dans",
  "deal.myDeals": "Mes offres",
  "deal.views": "{n} vues",

  "auth.verify": "Vérifier",
  "auth.login": "Connexion",
  "auth.welcomeBack": "Bon retour sur LytePress.",
  "auth.email": "E-mail",
  "auth.password": "Mot de passe",
  "auth.forgot": "Mot de passe oublié ?",
  "auth.newShopper": "Nouvel acheteur ?",
  "auth.createFree": "Créer un compte gratuit",
  "auth.areBusiness": "Vous êtes un commerce ?",
  "auth.registerBusiness": "Inscrivez votre commerce",
  "auth.welcomeBackToast": "Bon retour !",
  "auth.signedInAs": "Connecté en tant que {name}",
  "auth.loginFailed": "Échec de la connexion",
  "auth.invalidCreds": "Identifiants invalides",
  "auth.mfaTitle": "Vérification en deux étapes",
  "auth.mfaMsg": "Saisissez le code à 6 chiffres de votre application d'authentification, ou utilisez un code de secours.",
  "auth.mfaPlaceholder": "123456 ou code de secours",
  "auth.trustDevice": "Faire confiance à cet appareil 30 jours",
  "auth.skip2fa": "(sans 2FA la prochaine fois)",
  "auth.signupTitle": "Créez votre compte gratuit",
  "auth.signupMsg": "Suivez vos commerces préférés et soyez alerté dès qu'ils publient une offre.",
  "auth.yourName": "Votre nom",
  "auth.passwordMin": "Mot de passe (min. 6 caractères)",
  "auth.agreeTo": "En créant un compte, vous acceptez nos",
  "auth.and": "et notre",
  "auth.haveAccount": "Vous avez déjà un compte ?",
  "auth.logIn": "Connexion",
  "auth.signupFailed": "Échec de l'inscription",
  "auth.welcomeToLyte": "Bienvenue sur LytePress !",
  "qa.fixTitle": "Corrigeons d'abord ceci",
  "qa.uploadBlocked": "Photo refusée",
  "qa.pending": "Envoyé pour validation",
  "qa.pendingMsg": "Votre offre sera publiée dès que notre équipe l'aura validée.",
  "qa.watchNotice": "Vos offres sont vérifiées avant publication. Publiez normalement : la validation prend en général quelques heures.",
  "qa.title_short": "Donnez un vrai titre à l'offre (au moins 6 caractères) pour que les acheteurs comprennent.",
  "qa.title_long": "Ce titre est trop long : restez sous 90 caractères.",
  "qa.title_caps": "N'écrivez pas le titre EN MAJUSCULES : cela ressemble à du spam.",
  "qa.title_emoji": "Trop d'emojis dans le titre : deux au maximum.",
  "qa.desc_short": "Ajoutez une courte description (au moins 20 caractères) expliquant ce que les acheteurs obtiennent.",
  "qa.banned": "Ces termes ne sont pas autorisés sur LytePress. Retirez le contenu interdit ou pour adultes.",
  "qa.links": "Les liens et réseaux sociaux ne sont pas autorisés dans la description : les acheteurs vous contactent depuis votre profil, où vos coordonnées figurent déjà.",
  "qa.phone": "Ne mettez pas de numéro de téléphone dans la description : ajoutez-le à votre profil.",
  "qa.price_invalid": "Le prix et l'ancien prix doivent être des nombres.",
  "qa.disc_high": "Une remise supérieure à {max}% n'est pas crédible et les acheteurs la signalent. Merci de corriger.",
  "qa.was_low": "L'ancien prix doit être supérieur au prix de l'offre.",
  "qa.disc_mismatch": "Votre % de remise ne correspond pas aux prix : {price} au lieu de {was} fait {computed}% de remise, pas {discount}%.",
  "qa.dup_title": "Vous avez déjà une offre en ligne avec ce titre exact : modifiez-la ou changez ce titre.",
  "qa.img_small": "Cette photo ne fait que {w}×{h}px et paraîtrait floue. Envoyez au moins {minW}×{minH}px.",
  "qa.img_blank": "Cette image semble vide ou d'une seule couleur. Envoyez une vraie photo de l'offre.",
  "qa.img_blurry": "Cette photo semble floue. Envoyez une photo plus nette pour bien montrer l'offre.",
  "qa.img_unreadable": "Nous n'avons pas pu lire cette image. Envoyez une photo JPG, PNG ou WebP.",
  "qa.img_duplicate": "Cette photo est déjà utilisée par une autre entreprise sur LytePress. Envoyez votre propre photo.",
  "qa.ai_blocked": "Notre contrôle de contenu a bloqué cette offre (contenu pour adultes ou violent). Si c'est une erreur, écrivez à support@lytepress.com.",
  "qa.planLimit": "Vous avez atteint la limite d'offres de votre forfait",
  "qa.seePlans": "Voir les forfaits",
  "qa.coachGood": "Parfait",
  "qa.coachChecking": "Vérification de la photo…",
  "qa.coachSmall": "Trop petite ({w}×{h}px) : il faut {minW}×{minH}px",
  "qa.coachBlurry": "Semble floue : essayez une photo plus nette",
  "qa.coachBlank": "Semble vide : envoyez une vraie photo de l'offre",
  "invite.signInTitle": "Connectez-vous pour proposer un commerce",
  "invite.signInMsg": "Un compte gratuit prend quelques secondes et garantit des invitations authentiques.",
  "prc.badge": "Forfaits pour les commerces",
  "prc.h1": "Développez-vous plus vite avec LytePress",
  "prc.sub": "Publiez plus d'offres, apparaissez en premier et voyez où vous situez face au commerce voisin.",
  "prc.chipAnalytics": "Statistiques complètes",
  "prc.yourPlan": "Votre forfait : {plan}",
  "prc.dealsUsed": "{used} offres actives sur {limit}",
  "prc.unlimited": "illimitées",
  "prc.monthly": "Mensuel",
  "prc.yearly": "Annuel",
  "prc.save17": "−17 %",
  "prc.free": "Gratuit",
  "prc.freeSub": "Pour commencer",
  "prc.f3": "Suivi des vues",
  "prc.currentPlan": "Votre forfait actuel",
  "prc.pro": "Pro",
  "prc.perYear": "/ an",
  "prc.per30": "/ 30 jours",
  "prc.proYearNote": "Environ {monthly}/mois — 2 mois offerts",
  "prc.proMonthNote": "ou {yearly}/an — −17 %",
  "prc.p2": "Statistiques complètes et comparaison avec la concurrence",
  "prc.p4": "Alertez tous vos abonnés à chaque nouvelle offre",
  "prc.plus": "Elite",
  "prc.plusYearNote": "Soit {monthly}/mois — 2 mois offerts",
  "prc.plusMonthNote": "Pour les commerces à gros volume ou multi-sites",
  "prc.activeLife": "Actif à vie",
  "prc.renewsOn": "Renouvellement le {date}",
  "prc.endsOn": "Se termine le {date}",
  "prc.cancelRenewPro": "Annuler le renouvellement (Pro jusqu'à la fin)",
  "prc.cancelRenew": "Annuler le renouvellement automatique",
  "prc.resumeRenew": "Réactiver le renouvellement",
  "prc.goYearly": "Passer à l'annuel — {price}",
  "prc.goMonthly": "Passer au mensuel — {price}",
  "prc.guarantee": "Remboursé sous 14 jours —",
  "prc.guaranteeLink": "sans justification",
  "prc.boostTitle": "Besoin d'un coup de pouce ?",
  "prc.myAccount": "Mon compte",
  "prc.boostRefundPre": "Intégralement remboursable avant le début de la mise en avant — voir la",
  "prc.refundPolicy": "politique de remboursement",
  "prc.testMode": "Mode test — utilisez la carte 4242 4242 4242 4242, une date future et un CVC quelconque.",
  "prc.sp1": "Tous les prix sont en dollars américains. La TVA ou les taxes peuvent s'ajouter au paiement selon votre pays — le total exact s'affiche avant le règlement.",
  "prc.sp4pre": "Un doute ? Chaque paiement d'abonnement est couvert par notre",
  "prc.sp4link": "garantie satisfait ou remboursé de 14 jours",
  "prc.sp4post": "Les acheteurs n'paient jamais pour utiliser LytePress.",
  "prc.bizOnly": "Comptes professionnels uniquement",
  "prc.bizOnlyMsg": "Les forfaits payants sont destinés aux commerces qui publient des offres.",
  "prc.checkoutFail": "Impossible de lancer le paiement",
  "prc.tryAgain": "Veuillez réessayer.",
  "prc.renewOff": "Renouvellement automatique désactivé",
  "prc.renewOn": "Renouvellement automatique activé",
  "prc.subFail": "Impossible de mettre à jour l'abonnement",
  "ck.title": "Nous utilisons des cookies",
  "ck.body": "Nous utilisons des cookies essentiels pour faire fonctionner LytePress et des cookies facultatifs pour améliorer votre expérience. Consultez notre",
  "ck.privacy": "politique de confidentialité",
  "ck.acceptAll": "Tout accepter",
  "ck.essential": "Essentiels uniquement",
  "ck.dismiss": "Fermer",
  "undo.label": "Annuler",
  "undo.done": "Rétabli",
  "undo.failed": "Impossible d'annuler — réessayez",
  "follows.unfollow": "Ne plus suivre",
  "follow.follow": "Suivre",
  "follow.following": "Suivi",
  "follow.now": "Vous suivez {name}",
  "follow.nowMsg": "Nous vous préviendrons à chaque nouvelle offre.",
  "follow.stopped": "Vous ne suivez plus {name}",
  "follow.signInTitle": "Connectez-vous pour suivre",
  "follow.signInMsg": "Créez un compte acheteur gratuit pour recevoir les alertes.",
  "acc.shopperAccount": "Compte de shopper",
  "acc.verifiedSavingsThisMonth": "Économies vérifiées ce mois-ci",
  "acc.redeemADealCode": "Échangez un code de réduction en magasin pour commencer à accumuler des économies vérifiées.",
  "acc.topSaverEveryBadge": "Meilleur économiseur — chaque badge débloqué !",
  "acc.recentRedemptions": "Récents échanges",
  "acc.showPricesInMy": "Afficher les prix dans ma devise",
  "acc.dealsShowAnApproximate": "Les offres affichent un prix approximatif dans cette devise sur l'application.",
  "acc.showPricesAsIs": "Afficher les prix tels quels",
  "acc.emailPreferences": "Préférences d'email",
  "acc.newDealAlerts": "Alertes de nouvelles offres",
  "acc.emailMeWhenA": "Envoyez-moi un email quand une entreprise que je suis publie une nouvelle offre.",
  "acc.accountSecurityEmailsReceipts": "Les emails de compte et de sécurité (reçus, réinitialisations de mot de passe) sont toujours envoyés.",
  "acc.myRedemptionCodes": "Mes codes d'échange",
  "acc.businessesYouFollow": "Entreprises que vous suivez",
  "acc.youReNotFollowing": "Vous ne suivez pas encore d'entreprises. Suivez une entreprise pour être notifié lorsqu'elle publie une offre.",
  "acc.browseBusinesses": "Parcourir les entreprises",
  "acc.postADeal": "Publier une offre",
  "acc.redeemACustomerS": "Échanger le code d'un client",
  "acc.whenAShopperShows": "Lorsque un shopper montre son code ou QR à la caisse, scannez-le ou tapez-le ici pour confirmer et appliquer sa réduction.",
  "acc.pointTheCameraAt": "Dirigez la caméra vers le code QR du shopper.",
  "acc.dealsAlsoShowAn": "Les offres affichent également un prix approximatif dans cette devise sur l'application.",
  "acc.recommendedLogo": "Recommandé : logo",
  "acc.noCoverPhotoYet": "Pas encore de photo de couverture",
  "acc.contactInfo": "Informations de contact",
  "acc.showContactInfoOn": "Afficher les informations de contact sur mon profil public",
  "acc.addAnotherNumber": "Ajouter un autre numéro",
  "acc.saveContactInfo": "Enregistrer les informations de contact",
  "acc.upgradeForMore": "Améliorez pour plus",
  "acc.myDeals": "Mes offres",
  "acc.featureNudgeTitle": "Soyez #1 dans votre catégorie",
  "acc.featureNudgeBody": "Placez une de vos offres en haut de notre page d'accueil pour les acheteurs de votre pays — seulement 10 $ pour 24 heures.",
  "acc.featureNudgeCta": "Mettre une offre en avant",
  "acc.bookingsTitle": "Réservations à la une à venir",
  "acc.bookingCancel": "Annuler",
  "acc.bookingLive": "En cours",
  "acc.bookingCancelled": "Réservation annulée",
  "acc.bookingRefunded": "Annulée — remboursée sur votre carte",
  "acc.bookingCancelFailed": "Impossible d'annuler la réservation",
  "acc.youHavenTPosted": "Vous n'avez pas encore publié d'offres.",
  "acc.getListedTitle": "Vous n'êtes pas encore répertorié",
  "acc.getListedBody": "Les nouvelles entreprises n'apparaissent sur LytePress qu'une fois qu'elles publient une offre active. Publiez votre première offre pour être répertorié et commencer à toucher les clients près de chez vous.",
  "acc.postYourFirstDeal": "Publiez votre première offre",
  "acc.pendingReview": "En attente de révision",
  "acc.undoGrabReleaseThis": "Annuler la saisie — libérer ce code",
  "acc.enterCodeEG": "Entrez le code e.g. 7K9M2Q",
  "acc.labelEGPort": "Étiquette (par ex. succursale de Port of Spain)",
  "acc.removeNumber": "Supprimer le numéro",
  "acc.shareOfViewersWho": "Part des spectateurs qui ont réclamé cette offre",
  "acc.duplicateThisDealAnd": "Dupliquez cette offre et modifiez avant de relancer",
  "acc.couldNotUpdatePreferences": "Impossible de mettre à jour les préférences",
  "acc.grabUndone": "Saisie annulée",
  "acc.couldnTUndo": "Impossible d'annuler",
  "acc.codeRedeemed": "Code échangé ✓",
  "acc.couldnTRedeem": "Impossible d'échanger",
  "acc.cameraUnavailable": "Caméra indisponible",
  "acc.allowCameraAccessOr": "Autorisez l'accès à la caméra, ou tapez le code à la place.",
  "acc.saveMoreWasteLess": "Économisez plus. Gaspillez moins. — continuez à saisir des offres !",
  "acc.contactInfoSaved": "Informations de contact enregistrées",
  "acc.couldNotSave": "Impossible d'enregistrer",
  "acc.pleaseTryAgain": "Veuillez réessayer.",
  "acc.uploadFailed": "Échec de l'upload",
  "acc.dealRemoved": "Offre supprimée",
  "acc.couldNotRemove": "Impossible de supprimer",
  "acc.boostedForDays": "Boosté pendant 7 jours",
  "acc.couldNotStartCheckout": "Impossible de commencer le paiement",
  "acc.copyCreated": "Copie créée",
  "acc.couldNotDuplicate": "Impossible de dupliquer",
  "tfa.twoFactorAuthentication": "Authentification à deux facteurs",
  "tfa.addAnExtraLayer": "Ajoutez une couche de sécurité supplémentaire en utilisant une application d'authentification (Google Authenticator, Authy, 1Password).",
  "tfa.disableFa": "Désactiver 2FA",
  "tfa.trustedDevices": "Appareils de confiance",
  "tfa.revokeAllRequireFa": "Révoquer tout / exiger 2FA partout",
  "tfa.noTrustedDevicesWhen": "Aucun appareil de confiance. Lorsque vous vous connectez, cochez « Faire confiance à cet appareil pendant 30 jours » pour ignorer l'invite 2FA ici.",
  "tfa.eachCodeWorksOnce": "Chaque code fonctionne une fois si vous perdez votre authentificateur. Conservez-les en lieu sûr — ils ne seront plus affichés.",
  "tfa.copyAllCodes": "Copier tous les codes",
  "tfa.iVeSavedThem": "Je les ai sauvegardés",
  "tfa.confirmYourPasswordAnd": "Confirmez votre mot de passe et un code d'authentification actuel pour désactiver 2FA.",
  "tfa.yourPassword": "Votre mot de passe",
  "tfa.digitCode": "Code à 6 chiffres",
  "tfa.deviceRevoked": "Appareil révoqué",
  "tfa.thatDeviceWillNeed": "Cet appareil aura besoin d'un code 2FA la prochaine fois.",
  "tfa.couldNotRevokeDevice": "Impossible de révoquer l'appareil",
  "tfa.allTrustedDevicesRemoved": "Tous les appareils de confiance révoqués",
  "tfa.faWillBeRequired": "2FA sera requis sur chaque appareil.",
  "tfa.couldNotRevokeDevices": "Impossible de révoquer les appareils",
  "tfa.couldNotStartFa": "Impossible de commencer la configuration 2FA",
  "tfa.pleaseTryAgain": "Veuillez réessayer.",
  "tfa.twoFactorAuthenticationEnabled": "Authentification à deux facteurs activée ✓",
  "tfa.saveYourRecoveryCodes": "Sauvegardez vos codes de récupération en lieu sûr.",
  "tfa.couldnTVerifyCode": "Impossible de vérifier le code",
  "tfa.twoFactorAuthenticationDisabled": "Authentification à deux facteurs désactivée",
  "tfa.youCanReEnable": "Vous pouvez le réactiver à tout moment.",
  "tfa.couldNotDisableFa": "Impossible de désactiver 2FA",
  "trips.savedTrips": "Voyages enregistrés",
  "trips.saveADestinationAnd": "Enregistrez une destination et recevez des alertes de bonnes affaires avant votre arrivée.",
  "trips.addTrip": "Ajouter un voyage",
  "trips.pickAPopularCity": "Choisissez une ville populaire…",
  "trips.departureOptional": "Départ (optionnel)",
  "trips.noTripsYetSave": "Aucun voyage pour l'instant — enregistrez-en un pour recevoir des alertes de bonnes affaires avant votre atterrissage.",
  "trips.orSearchAnyCity": "…ou recherchez n'importe quelle ville, hôtel ou monument",
  "trips.searchPlace": "Rechercher un lieu",
  "trips.deleteTrip": "Supprimer le voyage",
  "trips.placeNotFound": "Lieu non trouvé",
  "trips.tryACityHotel": "Essayez une ville, un hôtel ou un monument.",
  "trips.addADestinationAnd": "Ajoutez une destination et une date de début",
  "trips.tripSavedUUfe": "Voyage enregistré \\u2708\\ufe0f",
  "trips.couldnTSaveTrip": "Impossible d'enregistrer le voyage",
  "hrs.openingHours": "Heures d'ouverture",
  "hrs.setOnceHereEvery": "Définissez une fois ici — chaque offre que vous publiez utilise ces heures pour montrer aux acheteurs quand vous êtes ouvert.",
  "hrs.timeZone": "Fuseau horaire",
  "hrs.copyMondayToAll": "Copier lundi à tous les jours",
  "hrs.holidayVacationMode": "Mode vacances / congés",
  "hrs.showsYourBusinessAs": "Affiche votre entreprise comme « Temporairement fermé » partout. Vos offres restent visibles.",
  "hrs.reopenDateOptional": "Date de réouverture (facultatif)",
  "hrs.messageOptional": "Message (facultatif)",
  "hrs.eGBackOn": "p. ex. Retour le 5 janv. — bonnes vacances !",
  "hrs.mondayCopiedToEvery": "Lundi copié à chaque jour",
  "hrs.tweakAnyDayThat": "Ajustez n'importe quel jour qui est différent, puis enregistrez.",
  "hrs.hoursSaved": "Heures enregistrées",
  "hrs.yourOpeningHoursNow": "Vos heures d'ouverture s'appliquent maintenant à toutes vos offres.",
  "hrs.couldNotSave": "Impossible d'enregistrer",
  "hrs.pleaseTryAgain": "Veuillez réessayer.",
  "br.businessLocations": "Emplacements des entreprises",
  "br.defaultCurrency": "Monnaie par défaut",
  "br.yourDefaultCurrencyIs": "Votre monnaie par défaut est verrouillée.",
  "br.itSFixedTo": "Elle est fixée à",
  "br.becauseYouAlreadyHave": "parce que vous avez déjà des offres en direct — cela maintient vos prix et vos échanges passés cohérents. Contactez le support si vous devez vraiment le changer.",
  "br.usedAsTheDefault": "Utilisé comme la monnaie de prix par défaut pour les nouvelles offres. Attention : cela se verrouille une fois que vous publiez votre première offre.",
  "br.weReMultinationalSet": "Nous sommes multinationales — définissez une monnaie par branche",
  "br.pinEveryBranchLocation": "Épinglez chaque emplacement/branche où vous opérez. Lorsque vous publiez une offre, ceux-ci sont utilisés automatiquement comme emplacements de l'offre — vous pouvez toujours les changer par offre.",
  "br.locationsSaved": "Emplacements enregistrés",
  "br.newDealsWillDefault": "Les nouvelles offres seront par défaut à ces emplacements et cette monnaie.",
  "br.couldNotSave": "Impossible d'enregistrer",
  "br.pleaseTryAgain": "Veuillez réessayer.",
  "tb.recentSearches": "Recherches récentes",
  "tb.didYouMean": "Vouliez-vous dire",
  "tb.noQuickMatchesPress": "Aucun résultat rapide — appuyez sur Entrée pour tout rechercher.",
  "tb.searchDeals": "Rechercher des offres",
  "tb.toggleAiAssistedSearch": "Activer/désactiver la recherche assistée par IA",
  "tb.findDealsNearMe": "Trouver des offres près de chez moi",
  "tb.removeFromRecentSearches": "Retirer des recherches récentes",
  "tb.showDealsEverywhere": "Afficher les offres partout",
  "tb.searchThisPlace": "Rechercher cet endroit",
  "tb.toggleTheme": "Changer de thème",
  "tb.locationSet": "Emplacement défini",
  "tb.placeNotFound": "Lieu non trouvé",
  "tb.tryADifferentCity": "Essayez une autre ville, un autre village ou un autre nom de lieu.",
  "tb.showingDealsEverywhere": "Affichage des offres partout",
  "tb.browsingDealsFromAll": "Parcourir des offres de tous les pays.",
  "tb.notSupported": "Non pris en charge",
  "tb.geolocationIsnTAvailable": "La géolocalisation n'est pas disponible dans ce navigateur.",
  "tb.locationFound": "Emplacement trouvé",
  "tb.locationPermissionDenied": "Autorisation de localisation refusée",
  "tb.allowLocationForThis": "Autorisez la localisation pour ce site dans les paramètres de la barre d'adresse de votre navigateur, puis appuyez à nouveau sur Près de chez moi.",
  "tb.locationTimedOut": "Délai d'attente de localisation dépassé",
  "tb.couldnTGetA": "Impossible d'obtenir une position à temps. Déplacez-vous vers un ciel dégagé ou réessayez — ou choisissez une ville ci-dessus.",
  "tb.locationUnavailable": "Emplacement indisponible",
  "tb.weCouldnTDetermine": "Nous n'avons pas pu déterminer votre position. Réessayez, ou choisissez un pays/une ville ci-dessus.",
  "an.couldNotLoadAnalytics": "Impossible de charger les analyses.",
  "an.performanceOfYourDeals": "Performance de vos offres et promotions.",
  "an.postADeal": "Publier une offre",
  "an.noDealsYetPost": "Pas d'offres pour l'instant — publiez votre première offre pour commencer à voir les analyses.",
  "an.yourAverageDiscountIs": "Votre remise moyenne est",
  "an.belowTheNearbyAverage": "en dessous de la moyenne locale de",
  "an.forYourCategoryA": "pour votre catégorie. Une remise légèrement plus importante attire généralement plus de vues et de partages.",
  "an.bestTimeToPost": "Meilleur moment pour publier",
  "an.newFollowersLastDays": "Nouveaux abonnés (14 derniers jours)",
  "an.viewsOverTime": "Vues au fil du temps",
  "an.lastDays": "14 derniers jours",
  "an.noViewDataYet": "Pas de données de vue pour l'instant — elles s'accumuleront au fur et à mesure que les acheteurs ouvrent vos offres.",
  "an.yourCompetition": "Votre concurrence",
  "an.liveDeals": "Offres en direct",
  "an.avgDiscount": "Remise moyenne",
  "an.tipClickARival": "Astuce : cliquez sur un concurrent pour comparer vos offres en direct côte à côte.",
  "an.redemptionsByDeal": "Remboursements par offre",
  "an.bestPerformer": "Meilleur performer",
  "an.redemptionsAreCustomersWho": "Les remboursements sont des clients qui ont montré leur code LytePress en magasin — preuve que la plateforme les a envoyés vers vous.",
  "an.redemptionsOverTime": "Remboursements au fil du temps",
  "an.dealLeaderboard": "Classement des offres",
  "an.byRedemptionRate": "par taux de remboursement",
  "an.viewsByCategory": "Vues par catégorie",
  "an.noDataYet": "Pas de données pour l'instant.",
  "an.topPerformingDeals": "Offres les plus performantes",
  "an.sharesOverTime": "Partages au fil du temps",
  "an.noSharesYetThis": "Pas de partages pour l'instant — cette ligne grandit à mesure que les acheteurs partagent vos offres avec leurs amis.",
  "an.mostSharedDeals": "Offres les plus partagées",
  "an.noSharesYetThis2": "Pas de partages pour l'instant — cela se remplit à mesure que les acheteurs utilisent le bouton de partage pour diffuser vos offres à leurs amis.",
  "an.loadingComparison": "Chargement de la comparaison…",
  "an.noLiveDeals": "Pas d'offres en direct.",
  "an.matchOrBeat": "Égaler ou battre",
  "an.totalViews": "Vues totales",
  "an.totalDeals": "Offres totales",
  "an.activeDeals": "Offres actives",
  "an.avgDiscount2": "Remise moyenne",
  "an.totalShares": "Partages totaux",
  "an.inStoreRedemptions": "Remboursements en magasin",
  "an.nearExpiry": "Proche de l'expiration",
  "reg.registerYourBusiness": "Enregistrez votre entreprise",
  "reg.startPostingDealsTo": "Commencez à publier des offres pour votre communauté.",
  "reg.whereIsYourBusiness": "Où se trouve votre entreprise ?",
  "reg.yourMainLocationYou": "Votre emplacement principal — vous pouvez ajouter d'autres succursales après l'inscription dans Mon Compte → Emplacements.",
  "reg.dealCurrency": "Monnaie de l'offre",
  "reg.byCreatingAnAccount": "En créant un compte, vous acceptez nos",
  "reg.termsOfUse": "Conditions d'utilisation",
  "reg.privacyPolicy": "Politique de confidentialité",
  "reg.alreadyRegistered": "Déjà inscrit ?",
  "reg.logIn": "Se connecter",
  "reg.yourName": "Votre nom",
  "reg.businessName": "Nom de l'entreprise",
  "reg.pickYourCity": "Choisissez votre ville",
  "reg.startTypingYourCity": "Commencez à taper votre ville et choisissez-la dans la liste.",
  "reg.accountCreated": "Compte créé !",
  "reg.registrationFailed": "Échec de l'inscription",
  "rst.setANewPassword": "Définissez un nouveau mot de passe",
  "rst.chooseAStrongPassword": "Choisissez un mot de passe fort que vous n'utilisez pas ailleurs.",
  "rst.forgotPassword": "Mot de passe oublié",
  "rst.newPassword": "Nouveau mot de passe",
  "rst.confirmNewPassword": "Confirmez le nouveau mot de passe",
  "rst.passwordTooShort": "Mot de passe trop court",
  "rst.useAtLeastCharacters": "Utilisez au moins 8 caractères.",
  "rst.passwordsDonTMatch": "Les mots de passe ne correspondent pas",
  "rst.passwordReset": "Réinitialisation du mot de passe ✓",
  "rst.youCanNowLog": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  "rst.couldnTResetPassword": "Impossible de réinitialiser le mot de passe",
  "fgt.checkYourEmail": "Vérifiez votre e-mail",
  "fgt.ifThatEmailIs": "Si cet e-mail est enregistré, nous avons envoyé un lien pour réinitialiser votre mot de passe. Il expire dans 45 minutes.",
  "fgt.forgotYourPassword": "Mot de passe oublié ?",
  "fgt.enterYourEmailAnd": "Entrez votre e-mail et nous vous enverrons un lien de réinitialisation.",
  "fgt.rememberedIt": "Vous vous en souvenez ?",
  "fgt.logIn": "Se connecter",
  "ct.contactUs": "Contactez-nous",
  "ct.questionsPartnershipsOrFeedback": "Questions, partenariats ou retours — nous aimerions avoir de vos nouvelles.",
  "ct.sendMessage": "Envoyer un message",
  "ct.yourName": "Votre nom",
  "ct.emailAddress": "Adresse e-mail",
  "ct.yourMessage": "Votre message",
  "ct.messageSent": "Message envoyé",
  "ct.thanksForReachingOut": "Merci de nous avoir contactés — nous répondons généralement sous un jour ouvré.",
  "st.ourStory": "Notre histoire",
  "st.saveMoreWasteLess": "Économisez plus. Gaspillez moins. Soutenez local.",
  "st.moreThanADirectory": "Plus qu'un annuaire. Plus qu'un site de bonnes affaires.",
  "st.lookingAheadOurGoal": "En regardant vers l'avenir, notre objectif est de nous développer sur le marché international — afin que les voyageurs et les touristes puissent ouvrir LytePress partout dans le monde et trouver instantanément les meilleures offres près d'eux, où que leur voyage les mène.",
  "st.thinkOfItThis": "Pensez-y de cette manière — des sites comme Expedia vous aident à planifier le voyage ; LytePress vous aide à économiser une fois que vous êtes là, avec les meilleures offres locales près de chez vous.",
  "st.whetherYouReA": "Que vous soyez une entreprise cherchant à atteindre de nouveaux clients ou un consommateur cherchant à découvrir ce qui se passe autour de vous, LytePress est là pour vous aider à économiser plus, gaspiller moins et soutenir local.",
  "st.exploreDeals": "Explorer les offres",
  "st.contactUs": "Contactez-nous",
  "st.supportLocal": "Soutenez local",
  "st.wasteLess": "Gaspillez moins",
  "st.communityFirst": "Communauté d'abord",
  "lg.lytepressOnlyEverCharges": "LytePress ne facture jamais que",
  "lg.onASingleDeal": "sur une seule offre, et un",
  "lg.shoppersNeverPayUs": "Les acheteurs ne nous paient jamais pour une offre. Chaque offre est vendue et échangée par l'entreprise qui l'a publiée, donc tout ce qui concerne les biens ou le service lui-même — le prix facturé en magasin, la qualité, la disponibilité, les échanges ou les remboursements — est entre l'acheteur et cette entreprise selon sa propre politique et la loi locale sur la consommation.",
  "lg.ifABusinessRefuses": "Si une entreprise refuse d'honorer une offre qu'elle a publiée, dites-le nous en utilisant l'option de signalement sur l'offre ou via la page de contact. Nous pouvons retirer l'offre et l'entreprise de LytePress, mais nous ne pouvons pas rembourser un achat pour lequel nous n'avons pas reçu de paiement.",
  "lg.ofThePaymentAnd": "du paiement et nous remboursons ce paiement en totalité. Aucune raison nécessaire, et cela s'applique aux plans mensuels et annuels.",
  "lg.cancelAndWeRefund": "annulez et nous remboursons en totalité.",
  "lg.thePlacementHasAlready": "le placement a déjà été livré aux acheteurs, il n'est donc pas remboursable. Vous pouvez toujours supprimer ou modifier l'offre, mais les dépenses restent utilisées.",
  "lg.ifAPlacementFailed": "Si un placement a échoué en raison d'une faute de notre part — il n'est jamais devenu actif, ou l'offre a été cachée par nous pendant la période — nous le remboursons en totalité ou le relançons, selon votre préférence.",
  "lg.emailUsFromThe": "Envoyez-nous un e-mail depuis l'adresse de votre compte LytePress, ou utilisez la page Contact, avec le nom de votre entreprise et la date de la charge. Nous répondons dans les 3 jours ouvrables. Les remboursements approuvés retournent à la méthode de paiement d'origine et peuvent prendre 5 à 10 jours ouvrables pour apparaître selon votre banque.",
  "lg.refundsIncludeAnyTax": "Les remboursements incluent toute taxe que nous avons facturée sur le paiement d'origine. Nous remboursons dans la devise dans laquelle vous avez été facturé — si votre banque a converti le montant, le chiffre qui arrive peut légèrement différer en raison des taux de change ou des frais bancaires que nous ne contrôlons pas.\n\nNos prix sont fixés en dollars américains (USD). Au moment du paiement, notre prestataire de paiement peut afficher et débiter le montant dans votre devise locale, converti à son propre taux de change. Toute transaction peut également être soumise à des frais de conversion de devise, des frais bancaires, des frais de l'émetteur de la carte ou d'autres frais appliqués par votre banque ou votre fournisseur de carte. Ceux-ci s'ajoutent au prix affiché, échappent à notre contrôle et sont à votre charge.",
  "lg.pleaseTalkToUs": "Veuillez nous parler avant de soulever un litige avec votre banque — nous pouvons presque toujours le résoudre plus rapidement. Les comptes avec un rétrofacturation non résolue peuvent avoir des fonctionnalités payantes suspendues jusqu'à ce que cela soit réglé.",
  "lg.youCanStopUsing": "Vous pouvez arrêter d'utiliser LytePress quand vous le souhaitez et supprimer vos offres de Mon Compte. Annuler un compte ne rembourse pas automatiquement un paiement déjà effectué — utilisez les règles ci-dessus.",
  "lg.billingQuestionsReachUs": "Questions de facturation ? Contactez-nous via la page Contact.",
  "lg.lytepressHelpsShoppersDiscover": "LytePress aide les acheteurs à découvrir des offres locales et mondiales et permet aux entreprises de publier des offres. Vous devez être en mesure de former un contrat contraignant pour utiliser le service, et vous acceptez de l'utiliser légalement.",
  "lg.youAreResponsibleFor": "Vous êtes responsable de la sécurité de votre connexion et de tout code à deux facteurs. Les comptes d'entreprise sont responsables de l'exactitude des offres, des prix, des succursales et des coordonnées qu'ils publient.",
  "lg.dealsAreOfferedBy": "Les offres sont proposées par les entreprises qui les publient, et non par LytePress. La disponibilité, les prix et le remboursement en magasin sont de la responsabilité de cette entreprise. Les codes de remboursement sont à usage unique, sauf indication contraire.",
  "lg.refundPolicy": "Politique de remboursement",
  "lg.donTPostUnlawful": "Ne publiez pas de contenu illégal, trompeur ou enfreignant, ne tentez pas de perturber le service, ou ne détournez pas les données d'autres utilisateurs.",
  "lg.weMayUpdateThese": "Nous pouvons mettre à jour ces termes ou le service, et pouvons suspendre les comptes qui les violent. L'utilisation continue après des modifications signifie que vous acceptez les termes mis à jour.",
  "lg.questionsAboutTheseTerms": "Questions sur ces termes ? Contactez-nous via la page Contact.",
  "lg.toRunTheService": "Pour faire fonctionner le service — vous montrer des offres pertinentes près de chez vous, envoyer des notifications d'offres auxquelles vous vous inscrivez, traiter les remboursements et les paiements, et garder votre compte sécurisé.",
  "lg.ifYouUseNear": "Si vous utilisez \"Près de moi\" ou le mode Touriste, nous utilisons l'emplacement que vous fournissez (ou l'emplacement de votre appareil, avec permission) uniquement pour trouver des offres à proximité. Vous pouvez toujours choisir un emplacement manuellement à la place.",
  "lg.ipAndGeo": "Pour améliorer votre expérience, nous utilisons votre adresse IP pour estimer votre localisation approximative (généralement votre pays), afin que la carte, les offres et la langue de l'interface se règlent par défaut sur l'endroit où vous êtes, plutôt que de toujours démarrer ailleurs. Il s'agit d'une estimation qui peut être inexacte ; vous pouvez changer de pays, de ville et de langue à tout moment, et ce choix prévaut sur l'estimation. La localisation GPS précise n'est utilisée que si vous appuyez sur \"Près de moi\" et donnez votre autorisation. Les estimations de localisation par IP sont conservées brièvement, uniquement pour accélérer les visites suivantes, et expirent automatiquement.",
  "lg.analyticsTitle": "Statistiques",
  "lg.analyticsBody": "Nous utilisons un logiciel d'analyse tiers respectueux de la vie privée (par exemple Plausible Analytics) pour comprendre comment le site est utilisé — par exemple quelles pages sont consultées et quelles fonctionnalités sont populaires. Cela peut impliquer qu'un prestataire d'analyse tiers traite des données d'utilisation anonymisées et agrégées pour notre compte. Ces outils fonctionnent sans cookies et ne vous suivent pas sur d'autres sites web ni ne créent de profil personnel vous concernant. Nous pouvons ajouter, changer ou retirer des prestataires d'analyse au fil du temps.",
  "lg.notResponsibleForDeals": "LytePress est uniquement une plateforme d'annonces. Les offres, prix, produits, services et conditions d'utilisation sont créés, proposés et honorés entièrement par les entreprises indépendantes qui les publient — ce ne sont pas nos offres. Nous ne vendons, ne fournissons, n'approuvons ni ne garantissons aucune offre, et nous ne sommes pas responsables de la disponibilité, de l'exactitude, de la qualité, de la sécurité ou de la légalité de ce qu'une entreprise propose, ni du fait qu'une entreprise refuse, modifie ou n'honore pas une offre. Tout achat ou utilisation est un contrat entre vous et cette entreprise ; tout litige concernant une offre est entre vous et elle. Veuillez vérifier les détails de chaque offre et les conditions de l'entreprise avant de vous y fier.",
  "lg.privacyQuestionsReachUs": "Questions de confidentialité ? Contactez-nous via la page Contact.",
  "lg.whatLytepressChargesFor": "1. Ce que LytePress facture",
  "lg.dealsAreNotSold": "2. Les offres ne sont pas vendues par LytePress",
  "lg.boostsAndFeaturedPlacements": "4. Boosts et placements en vedette",
  "lg.howToRequestA": "5. Comment demander un remboursement",
  "lg.taxesCurrencyAndFees": "6. Taxes, devise et frais",
  "lg.chargebacks": "7. Rétrofacturations",
  "lg.cancellingYourAccount": "8. Annuler votre compte",
  "lg.contact": "9. Contact",
  "lg.usingLytepress": "1. Utiliser LytePress",
  "lg.accounts": "2. Comptes",
  "lg.dealsRedemptions": "3. Offres & remboursements",
  "lg.payments": "4. Paiements",
  "lg.acceptableUse": "5. Utilisation acceptable",
  "lg.changesTermination": "6. Changements & résiliation",
  "dd.savedTo": "Enregistré dans",
  "dd.myDeals": "Mes Offres",
  "dd.save": "Enregistrer",
  "dd.saved": "Enregistré",
  "dd.favourite": "Enregistrer l'offre",
  "dd.backToDeals": "Retour aux offres",
  "dd.showThisAtCheckout": "Afficher cela à la caisse",
  "dd.changedYourMindUndo": "Vous avez changé d'avis ? Annuler la sélection",
  "bp.businessNotFound": "Entreprise non trouvée.",
  "bp.browseBusinesses": "Parcourir les entreprises",
  "bp.loading": "Chargement…",
  "bp.allBusinesses": "Toutes les entreprises",
  "bp.noLiveDealsRight": "Aucune offre en cours en ce moment — suivez pour être notifié lorsqu'ils en publient une.",
  "bp.verifiedBusiness": "Entreprise vérifiée",
  "bp.businessLocation": "Emplacement de l'entreprise",
  "bl.localGlobalMerchants": "Commerçants locaux et mondiaux",
  "bl.discoverBusinesses": "Découvrez des entreprises",
  "bl.followYourFavouriteShops": "Suivez vos magasins préférés et ne manquez jamais une nouvelle offre.",
  "bl.noBusinessesMatchThese": "Aucune entreprise ne correspond à ces filtres.",
  "bl.viewProfile": "Voir le profil",
  "dsh.seePricesInYour": "Voir les prix dans votre devise",
  "dsh.pickYourCurrencyAnd": "Choisissez votre devise et chaque offre affiche une estimation instantanée dans la monnaie que vous utilisez.",
  "dsh.chooseCurrency": "Choisir la devise…",
  "psx.confirmingYourPayment": "Confirmation de votre paiement…",
  "psx.thisOnlyTakesA": "Cela ne prend qu'un instant.",
  "psx.paymentSuccessful": "Paiement réussi !",
  "psx.yourUpgradeIsNow": "Votre mise à niveau est maintenant active. Merci de soutenir LytePress.",
  "psx.goToMyAccount": "Aller à Mon Compte",
  "psx.backToPremium": "Retour à Premium",
  "pcx.checkoutCancelled": "Caisse annulée",
  "pcx.noWorriesYouHave": "Pas de souci — vous n'avez pas été facturé.",
  "pcx.backToPremium": "Retour à Premium",
  "nf.thisPageTookA": "Cette page a pris un détour",
  "nf.thePageYouRe": "La page que vous recherchez n'existe pas ou a peut-être expiré. Revenons aux bonnes choses.",
  "nf.backHome": "Retour à l'accueil",
  "nf.browseDeals": "Parcourir les offres",
  "nf.goBack": "Retourner",
  "cat.exploreByCategory": "Explorer par catégorie",
  "cat.browseAll": "Parcourir tout",
  "cat.grabThemFast": "Prenez-les rapidement",
  "md.undoGrab": "Annuler la sélection",
  "bd.aiSearch": "Recherche IA",
  "bd.findingTheBestMatches": "Recherche des meilleures correspondances…",
  "bd.nearMe": "Près de moi",
  "bd.openNow": "ouvert maintenant",
  "bd.nearMe2": "près de moi",
  "bd.noExactMatchesSearching": "Aucune correspondance exacte — recherche par signification…",
  "lm.googleMapsApiKey": "Clé API Google Maps non configurée.",
  "lm.loadingMap": "Chargement de la carte...",
  "pdx.movePhotoLeft": "Déplacer la photo à gauche",
  "pdx.movePhotoRight": "Déplacer la photo à droite",
  "pdx.eGLyte": "p. ex. LYTE20",
  "pdx.couldNotLoadDeal": "Impossible de charger l'offre",
  "pdx.pleaseTryAgain": "Veuillez réessayer.",
  "pdx.photosAdded": "Photos ajoutées",
  "ip.addLytepressToYour": "Ajoutez LytePress à votre écran d'accueil",
  "ip.addToHomeScreen": "Ajouter à l'écran d'accueil",
  "ip.fasterAccessToDeals": "Accès plus rapide aux offres près de chez vous et à vos codes de réduction — pas besoin de magasin d'applications.",
  "rev.verifiedReviews": "Avis vérifiés",
  "rev.verifiedRedemption": "Rachat vérifié",
  "rev.redeemOneOfThis": "Récupérez l'une des offres de cette entreprise en magasin pour laisser un avis vérifié.",
  "rev.noReviewsYetBe": "Pas encore d'avis — soyez le premier après avoir récupéré une offre.",
  "rev.shareHowTheDeal": "Partagez comment s'est passée l'offre (facultatif)…",
  "rev.replyPubliclyToThis": "Répondez publiquement à cet avis…",
  "rev.pickAStarRating": "Choisissez une note étoilée",
  "rev.tapStarsToRate": "Appuyez sur 1–5 étoiles pour évaluer cette entreprise.",
  "rev.yourVerifiedReviewIs": "Votre avis vérifié est maintenant en ligne.",
  "rev.couldnTPostReview": "Impossible de publier l'avis",
  "rev.replyIsEmpty": "La réponse est vide",
  "rev.writeAShortReply": "Écrivez d'abord une courte réponse.",
  "rev.replyPosted": "Réponse publiée",
  "rev.shoppersCanNowSee": "Les acheteurs peuvent maintenant voir votre réponse.",
  "rev.couldnTPostReply": "Impossible de publier la réponse",
  "tm.touristMode": "Mode Touriste",
  "tm.localPrices": "Prix locaux",
  "tm.noneYet": "aucun pour l'instant",
  "tm.saveThisBase": "Enregistrer cette base",
  "tm.iMVisitingShow": "Je visite — montrez les meilleures offres près de moi",
  "tm.hotelLandmarkOrAddress": "Hôtel, point de repère ou adresse…",
  "tm.setBaseLocation": "Définir la localisation de base",
  "tm.exitTouristMode": "Quitter le mode touriste",
  "tm.removeBase": "Supprimer la base",
  "tm.touristModeOn": "Mode Touriste activé ✈️",
  "tm.showingDealsNearYou": "Affichage des offres près de chez vous, au prix de votre monnaie, avec des directions en un clic.",
  "tm.typeTheHotelLandmark": "Tapez l'hôtel, le point de repère ou la zone où vous séjournez pour voir les offres à proximité.",
  "tm.baseUpdated": "Base mise à jour 📍",
  "tm.placeNotFound": "Lieu non trouvé",
  "tm.tryAHotelName": "Essayez un nom d'hôtel, un point de repère ou une adresse.",
  "rpt.reportThisDeal": "Signaler cette offre",
  "rpt.tellUsWhatS": "Dites-nous ce qui ne va pas afin que notre équipe puisse l'examiner.",
  "rpt.reportDeal": "Signaler l'offre",
  "rpt.addAnyDetailsOptional": "Ajouter des détails (facultatif)",
  "rpt.spamOrMisleading": "Spam ou trompeur",
  "rpt.wrongOrFakePrice": "Prix incorrect ou faux",
  "rpt.offensiveOrInappropriate": "Offensant ou inapproprié",
  "rpt.expiredNoLongerAvailable": "Expiré / plus disponible",
  "rpt.somethingElse": "Autre chose",
  "rpt.signInToReport": "Connectez-vous pour signaler",
  "rpt.pleaseLogInTo": "Veuillez vous connecter pour signaler une offre.",
  "rpt.thanksForTheReport": "Merci pour le rapport",
  "rpt.ourTeamWillReview": "Notre équipe examinera cette offre.",
  "rpt.couldNotSubmitReport": "Impossible de soumettre le rapport",
  "dlp.mapUnavailableNoApi": "Carte indisponible (pas de clé API)",
  "dlp.loadingMap": "Chargement de la carte…",
  "dlp.useBusinessDefaultCurrency": "Utiliser la devise par défaut de l'entreprise",
  "dlp.openingHoursOverrideOptional": "Heures d'ouverture modifiées (optionnel)",
  "dlp.placeNotFound": "Lieu non trouvé",
  "dlp.tryADifferentAddress": "Essayez une autre adresse ou un autre nom de lieu.",
  "dlp.gpsUnavailable": "GPS indisponible",
  "dlp.searchAnAddressInstead": "Recherchez une adresse à la place.",
  "dlp.pinnedYourLocation": "Votre emplacement a été épinglé",
  "dlp.couldnTGetLocation": "Impossible d'obtenir l'emplacement",
  "dlp.allowLocationAccessOr": "Autorisez l'accès à la localisation ou recherchez une adresse.",
  "shb.shareDeal": "Partager l'offre",
  "shb.shareThisDeal": "Partager cette offre",
  "shb.linkCopied": "Lien copié",
  "shb.shareItWithFriends": "Partagez-le avec des amis !",
  "shb.couldnTCopyLink": "Impossible de copier le lien",
  "shs.shareMySavings": "Partager mes économies",
  "shs.copied": "Copié !",
  "shs.pasteItAnywhereTo": "Collez-le n'importe où pour inviter des amis.",
  "shs.couldnTCopy": "Impossible de copier",
  "shs.myLytepressSavings": "Mes économies LytePress",
  "rgc.monthlyRedemptionGoal": "Objectif de rachat mensuel",
  "rgc.redemptionsMonth": "rachats / mois",
  "rgc.setAMonthlyTarget": "Fixez un objectif mensuel pour suivre vos rachats et garder l'équipe motivée.",
  "rgc.goalReachedNicelyDone": "Objectif atteint — bien joué !",
  "obc.dismissChecklist": "Ignorer la liste de contrôle",
  "obc.profileLinkCopied": "Lien de profil copié",
  "obc.pasteItOnWhatsapp": "Collez-le sur le statut WhatsApp, la bio Instagram ou la vitrine de votre magasin.",
  "obc.hereSYourLink": "Voici votre lien",
  "obc.addYourLogo": "Ajoutez votre logo",
  "obc.addAContactNumber": "Ajoutez un numéro de contact",
  "obc.pinYourLocation": "Épinglez votre emplacement",
  "obc.postYourFirstDeal": "Publiez votre première offre",
  "obc.shareYourProfileLink": "Partagez le lien de votre profil",
  "rr.alertsEnabled": "Alertes activées",
  "rr.youLlBeNotified": "Vous serez informé des nouvelles offres (démo).",
  "pc.popularDestinations": "Destinations populaires",
  "sb.logOut": "Se déconnecter",
  "st.para1": "Nous croyons que découvrir de grandes entreprises locales devrait être facile, gratifiant et accessible à tous.",
  "st.para2": "Chaque jour, les entreprises lancent de nouveaux produits, créent des offres spéciales, organisent des événements, mènent des promotions et fournissent des services précieux dont de nombreux clients n'entendent jamais parler. En même temps, les consommateurs cherchent constamment des moyens d'économiser de l'argent, de découvrir de nouvelles expériences et de se connecter avec leurs communautés.",
  "st.para3": "Nous avons créé LytePress pour rassembler ces deux mondes.",
  "st.para4": "LytePress est une plateforme où les entreprises locales peuvent présenter des promotions, des événements, des cadeaux, des offres spéciales et des opportunités, tandis que les consommateurs peuvent découvrir de nouvelles façons d'économiser, de faire des achats, de dîner, d'explorer et de s'engager avec les entreprises qui les entourent.",
  "st.para5": "Nous sommes également engagés à réduire le gaspillage inutile en aidant les entreprises à promouvoir des produits en surplus et proches de la date d'expiration qui ont encore de la valeur, créant des avantages tant pour les entreprises que pour les consommateurs.",
  "st.valSupportLocal": "Connecter les communautés avec les entreprises qui les entourent.",
  "st.valWasteLess": "Promouvoir des produits en surplus et proches de la date d'expiration qui ont encore de la valeur.",
  "st.valCommunity": "Une communauté grandissante qui récompense les dépenses intelligentes et l'entrepreneuriat.",
  "st.sustainable": "Durable",
  "an.nViews": "{n} vues",
  "an.nViewsNDeals": "{v} vues · {d} offres",
  "an.nSharesNViews": "{s} partages · {v} vues",
  "dc.seeAllIn": "Voir toutes les offres {name}",
  "acc.nOfMLiveDeals": "{n} / {m} offres en direct",
  "cat.nLiveDeals": "{n} offres en direct",
  "cat.nCategories": "{n} catégories",
  "bl.allCategories": "Toutes les catégories",
  "reg.and": "et",
  "acc.planLabelPlan": "Plan {plan}",
  "acc.showInCurrency": "Afficher en {code} — {label}",
  "home.slide1a": "Super Offres.",
  "home.slide1b": "Moins de Déchets.",
  "home.slide1sub": "Découvrez les offres des commerces locaux et sauvez les produits bientôt périmés avant qu'ils ne disparaissent.",
  "home.slide1badge": "Économisez jusqu'à 70%",
  "home.slide2a": "Achetez Local.",
  "home.slide2b": "Économisez Plus.",
  "home.slide2sub": "Soutenez les commerces locaux et trouvez les offres qu'ils proposent près de chez vous.",
  "home.slide2badge": "Jusqu'à 60% de réduction",
  "home.slide3a": "Toutes les Offres.",
  "home.slide3b": "Au Même Endroit.",
  "home.slide3sub": "Toutes les catégories au même endroit, pour ne jamais manquer une offre locale.",
  "home.slide3badge": "Flash 50% de réduction",
  "home.vp1t": "Économisez de l'Argent",
  "home.vp1x": "Super réductions sur vos articles préférés",
  "home.vp2t": "Réduisez les Déchets",
  "home.vp2x": "Aidez les entreprises à réduire le gaspillage alimentaire et de produits",
  "home.vp3t": "Soutenez Local",
  "home.vp3x": "Renforcez les entreprises locales de votre communauté",
  "home.slideN": "Diapositive {n}",
  "vf.title": "Vérification de l'entreprise",
  "vf.riskyNote": "Ces catégories nécessitent une vérification avant que vous puissiez y publier : {list}",
  "vf.upload": "Télécharger le document",
  "vf.sent": "Documents envoyés",
  "vf.sentMsg": "Nous les examinerons et vous enverrons un e-mail — généralement dans la journée.",
  "vf.failed": "Impossible d'envoyer cela",
  "vf.pendingMsg": "Nous examinons vos documents — nous vous enverrons un e-mail lorsque ce sera fait.",
  "vf.verifiedMsg": "Votre entreprise est vérifiée. Le badge bleu apparaît sur votre profil et dans l'annuaire.",
  "vf.rejected": "Nous n'avons pas pu vérifier votre entreprise avec ces documents. Essayez des photos plus claires.",
  "vf.independent": "Vendeur indépendant",
  "vf.verifiedTag": "Entreprise vérifiée",
  "bl.allCountries": "Tous les pays",
  "bl.nDeals": "{n} offres",
  "sidebar.plusActive": "Elite actif",
  "sidebar.forLife": "Pour la vie",
  "cat.Bakery": "Boulangerie",
  "cat.Electronics": "Électronique",
  "cat.Food & Beverages": "Alimentation & Boissons",
  "cat.Groceries": "Épicerie",
  "cat.Health & Beauty": "Santé & Beauté",
  "cat.Restaurants": "Restaurants",
  "bl.nBusinesses": "{n} entreprises",
  "cat.subScoped": "Parcourez des offres sélectionnées dans chaque catégorie de {scope}. Appuyez sur une tuile pour plonger.",
  "cat.subGlobal": "Parcourez des offres sélectionnées dans chaque catégorie du monde entier. Appuyez sur une tuile pour plonger.",
  "cat.nLiveRightNow": "{n} en direct en ce moment",
  "browse.verifiedOnly": "Vérifié uniquement",
  "bl.verifiedOnly": "Vérifié uniquement",
  "map.verifiedOnly": "Vérifié uniquement",
  "browse.emptyVerified": "Aucune entreprise vérifiée n'a encore de bonnes affaires ici — essayez de désactiver « Vérifié uniquement ».",
  "trust.whatsThis": "Qu'est-ce que c'est ?",
  "trust.title": "Ce que signifie « vérifié »",
  "trust.verifiedTitle": "Entreprise vérifiée",
  "trust.independentTitle": "Vendeur indépendant",
  "trust.limitsTitle": "Ce qu'il ne promet pas",
  "trust.limitsBody": "Le badge concerne qui ils sont, pas une garantie du produit, du service ou du prix. Vérifiez toujours les conditions de l'offre avant d'acheter.",
  "trust.reportTitle": "Un problème ?",
  "trust.reportBody": "Appuyez sur Signaler sur n'importe quelle offre. Deux signalements l'alerteront pour notre équipe, et nous supprimons les offres qui induisent les acheteurs en erreur.",
  "trust.footer": "Les catégories sensibles — santé, événements, technologie et automobile — ne peuvent être publiées que par des entreprises vérifiées.",
  "apl.title": "Faire appel d'une décision",
  "apl.subtitle": "Quelque chose que nous avons mal fait ? Répondez une fois et nous réglerons cela ici.",
  "apl.appeal": "Faire appel",
  "apl.send": "Envoyer l'appel",
  "apl.cancel": "Annuler",
  "apl.reason": "Notre raison",
  "apl.placeholder": "Dites-nous ce qui s'est passé — plus vous êtes précis, plus vite nous pourrons le résoudre.",
  "apl.onceNote": "Vous pouvez faire appel de chaque décision une fois. Nous répondrons par email.",
  "apl.sent": "Appel envoyé",
  "apl.sentMsg": "Nous allons l'examiner et vous envoyer un email.",
  "apl.failed": "Impossible d'envoyer cela",
  "apl.pending": "Nous examinons votre appel",
  "apl.granted": "Résolu — nous sommes d'accord avec vous",
  "apl.declined": "Nous avons maintenu notre décision",
  "apl.deal": "Offre retirée : {title}",
  "apl.watch": "Vos offres sont examinées avant d'être mises en ligne",
  "apl.watchDetail": "Cela se produit après que deux offres ont été retirées.",
  "apl.suspension": "Votre compte est suspendu",
  "apl.verification": "La vérification n'a pas été approuvée",
  "qa.appeal_short": "Veuillez nous dire ce qui s'est passé en au moins 20 caractères — cela nous aide à régler cela rapidement.",
  "qa.appeal_once": "Vous avez déjà fait appel de cela une fois — nous répondrons par email.",
  "acc.activeDeals": "Offres actives",
  "acc.totalViews": "Vues totales",
  "acc.totalClaims": "Réclamations totales",
  "acc.nClaims": "{n} réclamations",
  "acc.nConversion": "{n} conversions",
  "acc.goesLive": "Se met en ligne {when}",
  "adn.title": "Options — ne payez que ce dont vous avez besoin",
  "adn.sub": "Les forfaits couvrent les fonctions qui ne nous coûtent rien. Celles-ci sont limitées ou demandent du vrai travail : elles se vendent séparément, en paiement unique, sans abonnement.",
  "adn.slotsTitle": "5 emplacements d'offres en plus",
  "adn.slotsBody": "Cinq emplacements d'offres actives en plus de votre forfait, pendant 30 jours. Rachetables à tout moment : ils se cumulent.",
  "adn.slotsCta": "Ajouter 5 emplacements — {price}",
  "adn.slotsActive": "{n} emplacements supplémentaires actifs",
  "adn.boostTitle": "Booster une offre",
  "adn.boostCta": "Booster depuis Mon compte",
  "adn.verifyTitle": "Vérification prioritaire",
  "adn.verifyBody": "Vos documents d'enregistrement passent en tête de la file d'examen au lieu d'attendre leur tour.",
  "adn.verifyCta": "Examen prioritaire — {price}",
  "adn.verifyDone": "Vous avez l'examen prioritaire — vos documents passent d'abord.",
  "adn.verifiedAlready": "Votre établissement est déjà vérifié.",
  "adn.oneOff": "Paiements uniques, pas des abonnements",
  "srv.title": "Que paieriez-vous en premier ?",
  "srv.sub": "Touchez tout ce qui s'applique. Vos réponses décident de ce que nous construisons et de son prix.",
  "srv.slots": "Plus d'emplacements d'offres",
  "srv.analytics": "Statistiques et comparaison",
  "srv.placement": "Placement en tête",
  "srv.verification": "Badge vérifié",
  "srv.followers": "Alerter mes abonnés",
  "srv.saved": "Merci, c'est noté.",
  "bo.title": "Booster cette offre",
  "bo.checking": "Vérification des emplacements libres près de vous…",
  "bo.slotsLine": "{n} sur {limit} emplacements sponsorisés libres dans un rayon de {km}km",
  "bo.choose": "Choisir",
  "bo.note": "Une liste n'affiche jamais plus de 3 offres sponsorisées : les commerces se relaient en tête chaque heure. Exclusif est la seule option qui ne se partage pas.",
  "bo.boostTitle": "Boost",
  "bo.boostBody": "Un des 3 emplacements sponsorisés pendant 7 jours, pour les clients à moins de 10km.",
  "bo.reachTitle": "Boost + Portée",
  "bo.reachBody": "Le même emplacement, mais vous apparaissez aussi jusqu'à 25km — pour les commerces où l'on se déplace.",
  "bo.exclTitle": "Exclusif",
  "bo.exclBlocked": "Exclusif exige tous les emplacements libres, et {n} boost(s) tournent encore. Libre le {date}.",
  "bst.kindReach": "Portée {km}km",
  "bst.kindExclusive": "Exclusif",
  "bst.shareCrowded": "{n} autres boosts couvraient votre zone : vous avez tenu une place en tête environ {pct}% du temps. Exclusif l'aurait fait tout le temps.",
  "bst.shareClear": "Vous avez eu une place en tête tout du long — aucune concurrence à proximité.",
  "tfa.enable2fa": "Activer la 2FA",
  "fn.title": "Comment les acheteurs interagissent avec vos offres",
  "fn.subtitle": "Trois étapes réelles. Pas de score de conversion inventé.",
  "fn.views": "Vues",
  "fn.grabs": "Saisies",
  "fn.redeemed": "Échangés en magasin",
  "fn.viewsNote": "Nombre de fois que vos pages d'offres ont été ouvertes — compté une fois par acheteur par jour.",
  "fn.grabsNote": "Acheteurs qui ont appuyé sur Saisir, donc l'offre est enregistrée dans leur poche.",
  "fn.redeemedNote": "Codes que vous avez scannés en magasin — la seule étape qui prouve une vraie visite.",
  "fn.grabRate": "{n}% des vues",
  "fn.redeemRate": "{n}% des saisies",
  "fn.honestTitle": "Ce que ces chiffres peuvent et ne peuvent pas vous dire",
  "fn.honestBody": "Nous pouvons seulement compter les pages d'offres ouvertes, les saisies et les codes que vous scannez en magasin. Nous ne pouvons pas voir les visites sans saisie, ce qu'un client a dépensé, ou s'il est revenu. Les offres sans code n'ont pas d'étape échangée.",
  "fn.sourcesTitle": "D'où viennent vos vues",
  "fn.sourcesEmpty": "Pas encore de sources de vues. Partagez une offre et revenez vérifier.",
  "fn.sourcesNote": "Les partages sont des liens que vous ou les acheteurs avez envoyés. Direct signifie que nous ne pouvions pas déterminer d'où la visite a commencé.",
  "fn.last30Days": "Derniers 30 jours",
  "fn.nViewsPercent": "{n} vues · {p}%",
  "fn.nGrabs": "{n} saisies",
  "fn.nRedeemed": "{n} échangés",
  "fn.directionsTitle": "{n} personnes ont demandé des directions",
  "fn.directionsNote": "Appuis sur Directions depuis la carte ou la page de l'offre — le signe le plus fort que quelqu'un s'est dirigé vers votre magasin.",
  "fn.nDirections": "{n} directions",
  "map.homeMapNote": "La vue de la carte est votre maison en ce moment",
  "map.classicHome": "Maison classique",
  "map.homeClassicNote": "Préférez-vous la carte comme écran d'accueil ?",
  "map.openMap": "Utiliser la carte comme maison",
  "map.alertMe": "Alertez-moi ici",
  "map.alertSignIn": "Connectez-vous gratuitement pour recevoir des alertes pour cette zone.",
  "map.alertSaved": "Vous recevrez une notification pour {area}",
  "map.alertSavedDesc": "{n} offres sont disponibles ici maintenant, dans un rayon d'environ {km} km. Gérez les alertes sous Suivi.",
  "map.alertFailed": "Impossible de sauvegarder cette alerte de zone. Veuillez réessayer.",
  "map.thisArea": "Cette zone",
  "map.areasSection": "Alertes de zone ({n})",
  "map.areaRadius": "Dans un rayon d'environ {km} km",
  "map.areaRemoved": "Alertes désactivées pour {area}",
  "map.shareDialogTitle": "Partager cette vue de carte",
  "map.sharePreview": "{n} offres en vue — économisez jusqu'à {best}%",
  "map.sharePreviewNote": "C'est à peu près à quoi ressemblera le lien lorsque quelqu'un l'obtiendra.",
  "map.shareNoteLabel": "Ajouter une note (facultatif)",
  "map.shareNotePlaceholder": "Course de déjeuner — rendez-vous près de la pâtisserie ?",
  "map.shareNow": "Partager le lien",
  "map.boostedPin": "Boosté",
  "map.shareCancel": "Annuler",
  "home.mapTitle": "Offres sur la carte",
  "home.mapSubtitle": "{n} offres épinglées où vous pouvez vraiment entrer",
  "home.mapOpenFull": "Ouvrir le LyteMap complet",
  "home.mapNote": "Les épingles rouges se terminent dans 24 heures. Les épingles à bord doré sont mises en avant par le magasin.",
  "ct.subject": "Sujet",
  "ct.sending": "Envoi en cours…",
  "ct.messageTooShort": "Veuillez ajouter un peu plus de détails pour que nous puissions vous aider.",
  "ct.messageFailed": "Nous n'avons pas pu envoyer cela",
  "ct.tryAgainLater": "Veuillez réessayer dans un moment.",
  "ct.replyNote": "Nous lisons chaque message et répondons généralement dans un délai d'un jour ouvrable.",
  "lg.boostsIntro": "Un Boost achète de l'attention pour une période fixe, donc le timing est important.",
  "lg.boostStartsNowLabel": "Cela commence dès que vous payez :",
  "lg.boostStartsNow": "un Boost devient actif sur votre offre immédiatement et dure pendant les jours que vous avez achetés, donc il ne peut pas être annulé pour un remboursement une fois acheté. Si vous en achetez un par erreur, contactez-nous le même jour et nous réglerons cela.",
  "lg.refundTimeline": "Les paiements par carte sont gérés par notre processeur de paiement (Stripe) — nous ne voyons jamais ni ne stockons vos informations de carte. Les remboursements approuvés sont renvoyés sur la même carte et apparaissent généralement dans un délai de 5 à 10 jours ouvrables, selon votre banque.",
  "bst.reportTitle": "Ce que vos boosts ont fait",
  "bst.reportSub": "Chaque boost à côté de la même période juste avant qu'il ne commence.",
  "bst.running": "En cours",
  "bst.finished": "Terminé",
  "bst.directionsShort": "Itinéraires",
  "bst.reportNote": "Les offres boostées prennent des tours en haut — l'ordre tourne chaque heure pour que chaque boutique boostée obtienne une part équitable.",
  "bst.slotsLeft": "{n} sur {limit} emplacements de boost disponibles pour {category} à {city} en ce moment",
  "bst.slotsFull": "Les {limit} emplacements de boost pour {category} à {city} sont tous actifs",
  "bst.slotsNote": "Nous limitons les boosts actifs à {limit} dans un rayon de {km}km autour de chaque commerce, pour qu'une épingle dorée se distingue toujours.",
  "bst.slotsLeftNear": "{n} sur {limit} emplacements de boost disponibles pour {category} dans un rayon de {km}km autour de votre commerce",
  "bst.slotsFullNear": "Les {limit} emplacements de boost pour {category} dans un rayon de {km}km autour de votre commerce sont actifs",
  "bst.nextFree": "Le prochain emplacement s'ouvre {when} — un boost dure 7 jours pleins à partir de l'achat.",
  "bst.notifyMe": "Prévenez-moi quand un emplacement se libère",
  "bst.notifyQueued": "Vous êtes sur la liste — nous vous écrirons dès qu'un emplacement {category} se libère.",
  "bst.ownBoostLive": "\"{title}\" est déjà boostée dans {category} — un boost actif par catégorie, vous ne surenchérissez jamais contre vous-même.",
  "adn.boostBody": "En haut de la navigation, recherche, la carte, Fin bientôt et les offres à la maison pendant 7 jours. Seulement 3 boosts en cours à la fois dans un rayon de 10 km de votre magasin, donc le badge garde sa signification.",
  "bo.exclBody": "Vous occupez les 3 emplacements et vous vous classez jusqu'à 25 km : votre offre est la seule sponsorisée dans votre catégorie à proximité. Maximum deux semaines, puis la catégorie se rouvre.",
  "bo.close": "Fermer",
  "adn.featTitle": "En vedette sur la page d'accueil",
  "adn.featBody": "Votre offre occupe l'unique emplacement À la une de sa catégorie sur la page d'accueil pendant 24 heures — la seule offre en vedette dans cette catégorie, montrée aux acheteurs du monde entier. Boost vous élève dans la navigation, la carte et la recherche ; À la une vous place sur la page d'accueil.",
  "adn.featCta": "Mettre en vedette depuis Mon Compte",
  "card.sponsored": "Sponsorisé",
  "lg.listingDiscretion": "Maintenir LytePress intéressant signifie que nous examinons ce qui est publié. Nous pouvons éditer, archiver ou supprimer toute annonce, et retirer l'accès au service, lorsque nous jugeons cela nécessaire — par exemple, du contenu qui semble inexact, dangereux, dupliqué ou hors de propos. Nous informerons normalement l'entreprise des raisons, bien que nous ne soyons pas obligés de demander d'abord.",
  "lg.listingModerationRecords": "Le contenu que vous publiez — offres, photos et détails de l'entreprise — est examiné dans le cadre de la gestion du service, et une copie d'une annonce que nous supprimons peut rester dans nos dossiers internes pendant un certain temps afin que nous puissions gérer les appels, les litiges et les problèmes récurrents.",
  "lg.termsOfUse": "Conditions d'utilisation",
  "lg.privacyPolicy": "Politique de confidentialité",
  "bo.excl14Title": "Exclusif · 2 semaines",
  "bo.excl14Body": "Le même verrouillage, payé d'avance pour la totalité de la quinzaine et moins cher que deux semaines individuelles. Après cela, la catégorie rouvre pour tout le monde.",
  "bo.extendTitle": "Prolongez ce boost",
  "bo.extendLine": "Valable jusqu'au {date} — des jours supplémentaires sont ajoutés à la fin, vous ne perdez rien.",
  "bo.addDays": "Ajouter {n} jours",
  "bo.extendNote": "Les jours supplémentaires commencent lorsque votre période actuelle se termine, donc votre offre ne sort jamais des emplacements sponsorisés en milieu de semaine.",
  "bo.exclRunway": "Vous avez maintenu Exclusif pendant {held} de {max} jours consécutifs. La catégorie rouvre pour tout le monde jusqu'au {date}.",
  "sr.title": "Emplacements sponsorisés près de chez vous",
  "sr.sub": "Seulement {limit} emplacements sponsorisés en cours à la fois dans chaque catégorie dans un rayon de {km}km de votre magasin. Voici ce qui est disponible en ce moment.",
  "sr.loading": "Vérification des emplacements autour de votre magasin…",
  "sr.open": "{n} sur {limit} disponibles dans un rayon de {km}km",
  "sr.full": "Tous les {limit} en cours en ce moment",
  "sr.fullNext": "Tous les {limit} en cours — le prochain s'ouvre le {date}",
  "sr.exclusiveHeld": "Un magasin détient l'Exclusivité ici jusqu'au {date}",
  "sr.watch": "Surveiller",
  "sr.watching": "En train de surveiller",
  "sr.watchOn": "Nous vous préviendrons dès qu'un emplacement {category} s'ouvre",
  "sr.watchOff": "Arrêt de la surveillance de {category}",
  "sr.buyPass": "Acheter un Pass Boost — {price}",
  "sr.passesHeld": "{n} Pass Boost prêt à l'emploi",
  "sr.note": "Un Pass Boost est un boost payé à l'avance au prix normal — gardez-le jusqu'à ce qu'un emplacement s'ouvre, puis utilisez-le d'un simple clic. Il n'expire jamais et ne fait pas sauter la file d'attente, donc le plafond reste équitable.",
  "fp.title": "Voici votre emplacement en vedette",
  "fp.honest": "C'est le seul emplacement À la une pour votre catégorie — la seule offre en vedette que les acheteurs y voient, dans le monde entier.",
  "fp.note": "À la une est la rangée de la page d'accueil — un seul emplacement par catégorie. Choisissez votre pays (vu par les acheteurs locaux) ou le monde entier (vu partout). Dure 24 heures ; racheter pendant qu'elle est active ajoute un jour de plus à la fin.",
  "fp.reachLocal": "Mon pays",
  "fp.reachLocalNote": "En tête de votre catégorie pour les acheteurs d'ici",
  "fp.reachGlobal": "Dans le monde entier",
  "fp.reachGlobalNote": "En tête de votre catégorie partout",
  "fp.today": "Aujourd'hui (démarrer)",
  "fp.pickDay": "Commencez aujourd'hui ou réservez un jour",
  "fp.notNow": "Pas maintenant",
  "fp.buy": "Mettez-le en avant — {price}",
  "bo.extendSame": "Ajoute {n} jours de plus à ce que vous avez en cours.",
  "bo.extendToReach": "Ajoute {n} jours et élargit votre portée de 10 km à 25 km pour toute la durée.",
  "bo.extendToExclusive": "Ajoute {n} jours et prend les 3 emplacements sponsorisés, jusqu'à 25 km.",
  "bo.extendNarrower": "Ajoute des jours, mais réduit votre portée à 10 km.",
  "pc.placeholder": "Code de réduction",
  "pc.apply": "Appliquer",
  "pc.remove": "Retirer le code",
  "pc.invalid": "Ce code n'est pas valide.",
  "pc.appliedPct": "{code} — {n}% de réduction",
  "pc.appliedAmt": "{code} — {n}€ de réduction",
  "pc.haveCode": "Vous avez un code de réduction ?",
  "prc.f2": "Une épingle sur la carte & profil public",
  "prc.p3": "Jusqu'à 3 emplacements épinglés",
  "acc.frontPageForDays": "En vedette pendant 7 jours",
  "br.limitNote": "{plan} couvre {cap} emplacement(s) épinglé(s). Pro épingle 3 et Elite est illimité.",
  "br.overLimit": "Vous avez plus d'emplacements enregistrés que ce que {plan} couvre ({cap}). Tout ce qui est déjà publié reste sur la carte — passez à un niveau supérieur pour enregistrer les modifications ici.",
  "acc.archived": "Archivé",
  "acc.archivedWhy": "Retiré :",
  "acc.archivedNoReason": "Aucune raison n'a été donnée — demandez-nous et nous expliquerons.",
  "acc.explainAppeal": "Expliquez ce qui s'est passé →",
  "sl.shareMsg": "Nous avons {n} promotions en ce moment — jetez un œil :",
  "sl.copy": "Copier le lien",
  "sl.copied": "Lien copié",
  "sl.copiedNote": "Collez-le n'importe où — il s'ouvre directement sur votre page boutique.",
  "bst.kindFeatured": "En vedette sur la page d'accueil, {km}km",
  "bo.extendLocked": "Vous avez {kind} — ajoutez des jours à celui-ci pour ne pas le perdre. Vous pouvez changer une fois la période écoulée.",
  "fp.slots": "L'emplacement À la une pour votre catégorie est libre — réservez-le pour 24 heures.",
  "fp.full": "L'emplacement À la une pour votre catégorie est pris pour le moment — le prochain ouvre le {date}. Il y a un emplacement par catégorie.",
  "prc.chipFeatured": "Placement prioritaire",
  "prc.chipCredits": "Boosts et mises en avant en option",
  "prc.boostLeft": "{n} Pass Boost restants",
  "prc.p5": "Rapports de promotion sur chaque Boost ou mise en avant",
  "prc.boostBody": "Les Boosts et les placements en avant ne sont jamais inclus dans un plan — achetez-les seulement quand vous en avez besoin. Boostez une seule offre pour {price} pour la fixer en haut de la navigation et de la carte pendant 7 jours — trouvez le bouton Boost sur vos offres dans",
  "acc.usedBoostPass": "A utilisé un Pass Boost — {n} restants.",
  "acc.couldNotUseYour": "Impossible d'utiliser votre Pass Boost",
  "prc.plusIncludesPro": "Tout ce qui est dans Pro, plus :",
  "prc.b4": "Support prioritaire — vos messages passent en premier",
  "sl.title": "Le lien de votre boutique",
  "sl.sub": "Un lien pour tout ce que vous avez — {n} en direct en ce moment. Collez-le dans WhatsApp et il affiche le nom de votre boutique, votre logo et combien d'offres sont disponibles.",
  "sl.on": "Lien activé",
  "sl.off": "Lien désactivé",
  "sl.switchedOn": "Le lien de votre boutique est en ligne",
  "sl.switchedOff": "Le lien de votre boutique est désactivé",
  "sl.offNote": "Votre lien est désactivé, donc il ne s'ouvrira pour personne. Réactivez-le quand vous voulez partager à nouveau.",
  "sl.needVerified": "Les liens de boutique nécessitent une vérification — c'est ce qui empêche quiconque d'échanger sous votre nom. Envoyez vos documents et le vôtre s'active automatiquement, construit à partir du nom de votre entreprise.",
  "sl.getVerified": "Obtenez la vérification",
  "sl.dealLinks": "Chaque offre a aussi son propre lien — voici “{title}” :",
  "prc.b3": "Placement prioritaire dans Parcourir et sur la carte, partagé équitablement",
  "prc.sp3": "Les limites des offres en direct comptent les offres publiées ou programmées et non encore expirées — Gratuit 2, Pro 15, Elite 100. Elite couvre également 25 emplacements épinglés. Ces plafonds sont un usage équitable, pas un mur : si votre chaîne a besoin de plus, envoyez un e-mail au support et nous les augmenterons sur votre compte. Le placement prioritaire est un départage entre les offres qui sont à la même distance de l'acheteur, partagé équitablement entre les magasins Elite — il ne place jamais un magasin au-dessus d'un autre qui est réellement plus proche.",
  "prc.firstTermOnly": "{price} pour ce terme avec votre code — se renouvelle à {full}",
  "prc.promoTermOnly": "Les codes s'appliquent au terme que vous achetez. Les renouvellements sont facturés automatiquement au prix habituel, la réduction ne vaut donc que pour ce premier terme.",
  "prc.sp2": "Les plans se renouvellent automatiquement pour que votre boutique ne s'arrête jamais. Vous payez pour une période (Pro {pro} / 30 jours ou {proYear} / an ; Elite {plus} / 30 jours ou {plusYear} / an) ; votre carte est enregistrée en toute sécurité par notre prestataire de paiement, Stripe, et débitée automatiquement au début de chaque nouvelle période — jusqu'à ce que vous désactiviez le renouvellement automatique, ce que vous pouvez faire à tout moment depuis cette page. Si un paiement de renouvellement échoue, votre plan continue de fonctionner pendant une période de grâce de 3 jours pendant que nous réessayons. Un code de réduction s'applique uniquement à la période où il est utilisé — les renouvellements sont facturés au prix de liste. Les plans n'incluent jamais les Boosts ou les placements en vedette : ce sont des frais ponctuels, pas des abonnements.",
  "lg.proSubscription": "abonnement (Pro ou Elite)",
  "lg.placementShoppersUseLytepress": "placement, plus un petit nombre d'options ponctuelles (emplacements de deals supplémentaires, un Boost Pass ou vérification prioritaire). Les acheteurs utilisent LytePress gratuitement.",
  "lg.ifYouReNot": "Si vous n'êtes pas satisfait d'un plan, demandez-nous dans",
  "lg.afterDaysASubscription": "Un plan est acheté pour une période (30 jours ou un an) et se renouvelle automatiquement. Votre carte est enregistrée en toute sécurité par notre prestataire de paiement, Stripe — jamais par nous — et débitée au début de chaque nouvelle période afin que votre plan continue sans interruption. Vous pouvez désactiver le renouvellement automatique à tout moment depuis la page Tarifs ; vous conservez tout ce que vous avez payé jusqu'à la fin de la période en cours, et rien n'est débité ensuite. Si un paiement de renouvellement échoue, les avantages de votre plan se poursuivent pendant une période de grâce de 3 jours pendant que nous réessayons, après quoi le compte passe à Gratuit. Après 14 jours, un paiement pour une période déjà en cours n'est pas remboursable, et vous conservez tout ce que vous avez payé jusqu'à la fin de cette période.",
  "lg.ifARenewalCharge": "Un code de réduction s'applique uniquement à la période où il a été utilisé : les renouvellements sont facturés au prix de liste. Vous pouvez voir votre date de renouvellement et désactiver le renouvellement automatique à tout moment sur la page Tarifs. Si un renouvellement vous surprend, contactez-nous — lorsqu'une période payée n'est pas utilisée, nous la remboursons normalement par courtoisie.",
  "lg.premiumSubscriptionsAndDeal": "Les plans, Boosts, emplacements en vedette et options sont facturés via notre processeur de paiement. Les Boosts et les emplacements en vedette ne sont jamais inclus dans un plan — ce sont des achats ponctuels séparés, et ils sont limités en nombre dans chaque zone, donc un emplacement n'est disponible que tant qu'un slot près de votre magasin est libre. L'offre Elite et les allocations de localisation sont des plafonds d'utilisation équitable, et \"placement prioritaire\" signifie seulement qu'une offre Elite est affichée en premier lorsque deux offres sont à la même distance de l'acheteur — cela ne place jamais un magasin au-dessus d'un autre qui est réellement plus proche. Les frais sont affichés avant l'achat. Des taxes peuvent s'appliquer en fonction de votre emplacement. Les remboursements sont couverts par notre",
  "lg.accountDetailsNameEmail": "Détails du compte (nom, email, rôle), informations de profil d'entreprise (nom de l'entreprise, catégorie, emplacement, numéros de contact, logo/couverture), et vos préférences (devise d'affichage, entreprises suivies, emplacement). Si vous activez l'authentification à deux facteurs, nous stockons un secret chiffré et des codes de récupération hachés. Si vous ajoutez une clé d'accès, nous stockons sa clé publique et un compteur de signature. Si vous envoyez des commentaires ou un message de support, nous conservons le message, et votre email uniquement si vous en avez fourni un, afin que nous puissions répondre.",
  "lg.businessContactDetailsAre": "Les coordonnées de contact de l'entreprise ne sont affichées publiquement que lorsque l'entreprise choisit de les rendre publiques. Le lien public d'un magasin vérifié (/s/nom-du-magasin) et ses liens de deals montrent le nom, le logo et les deals en direct de ce magasin à quiconque possède le lien — le magasin peut désactiver ce lien à tout moment. Nous ne vendons pas vos données personnelles. Nous partageons des données limitées avec notre processeur de paiement pour finaliser les achats.",
  "lg.passwordsAreHashedFa": "Les mots de passe sont hachés, les secrets à deux facteurs sont chiffrés au repos, et les actions sensibles sont limitées en fréquence. Si vous ajoutez une clé d'accès, nous stockons uniquement sa clé publique et un compteur — jamais votre empreinte digitale, votre visage ou votre code PIN de l'appareil, qui ne quittent jamais votre appareil. Aucun système n'est parfaitement sécurisé, alors veuillez utiliser un mot de passe fort et ajouter une clé d'accès ou 2FA.",
  "lg.youCanEditYour": "Vous pouvez modifier votre profil, cacher vos informations de contact publiques, gérer les appareils de confiance et les clés d'accès, activer ou désactiver 2FA, désactiver votre lien public de magasin, et ajuster les notifications à tout moment depuis Mon Compte. Pour faire supprimer votre compte et vos données personnelles, envoyez un email à support@lytepress.com et nous agirons dans les 30 jours.",
  "lg.proSubscriptionsDayMoney": "3. Plans — comment fonctionne la facturation et remboursement de 14 jours",
  "lg.lawDisputes": "7. Droit & litiges",
  "lg.termsContact": "8. Contact",
  "auth.or": "ou",
  "fb.button": "Retour d'information",
  "fb.title": "Dites-nous ce que vous en pensez",
  "fb.sub": "Tout ce qui est cassé, manquant ou brillant — cela nous parvient directement. Aucun compte nécessaire.",
  "fb.typeBug": "Quelque chose est cassé",
  "fb.typeIdea": "J'ai une idée",
  "fb.typeCompliment": "Quelque chose que j'adore",
  "fb.typeOther": "Autre chose",
  "fb.messagePlaceholder": "Dites-nous ce qui s'est passé, ou ce que vous aimeriez voir…",
  "fb.emailLabel": "Email (optionnel — uniquement pour que nous puissions répondre)",
  "fb.send": "Envoyer",
  "fb.sent": "Merci — c'est avec nous",
  "fb.sentNote": "Une personne lit chacun de ces messages. Nous répondrons si vous avez laissé un email.",
  "fb.failed": "Impossible d'envoyer cela",
  "fb.tooShort": "Encore quelques mots et nous saurons quoi corriger",
  "pk.title": "Clés d'accès",
  "pk.sub": "Connectez-vous avec Face ID, votre empreinte digitale ou votre code PIN de l'appareil. Votre mot de passe continue de fonctionner comme sauvegarde.",
  "pk.add": "Ajouter une clé d'accès",
  "pk.added": "Clé d'accès ajoutée",
  "pk.addedNote": "La prochaine fois, appuyez sur \"Se connecter avec une clé d'accès\" — pas de mot de passe à taper.",
  "pk.removed": "Clé d'accès supprimée",
  "pk.remove": "Supprimer",
  "pk.none": "Pas encore de clés d'accès. Ajoutez-en une et cet appareil peut vous connecter sans mot de passe.",
  "pk.unsupported": "Ce navigateur ne prend pas encore en charge les clés d'accès — votre mot de passe et 2FA fonctionnent toujours normalement.",
  "pk.cancelled": "Annulé",
  "pk.failed": "Cela n'a pas fonctionné",
  "pk.lastUsed": "Dernière utilisation {date}",
  "pk.never": "Pas encore utilisé",
  "pk.signIn": "Se connecter avec une clé d'accès",
  "pk.loginFailed": "Impossible de vous connecter",
  "pk.loginFailedNote": "Essayez votre mot de passe, ou ajoutez une clé d'accès depuis Mon Compte d'abord.",
  "cq.need": "Besoin de plus d'espace ?",
  "cq.title": "Demander des limites plus élevées",
  "cq.sub": "Elite couvre {deals} deals en direct et {branches} emplacements en tant qu'utilisation équitable. Dites-nous ce dont votre chaîne a réellement besoin et nous le réglerons.",
  "cq.deals": "Deals en direct dont vous avez besoin",
  "cq.branches": "Emplacements dont vous avez besoin",
  "cq.notePlaceholder": "Tout ce que nous devrions savoir — combien de succursales vous gérez, ce que vous prévoyez…",
  "cq.send": "Envoyer la demande",
  "cq.sentTitle": "Demande envoyée",
  "cq.sentNote": "Nous allons l'examiner et vous envoyer un email — généralement dans la journée.",
  "cq.pending": "Limites supérieures demandées — nous vous enverrons un email",
  "cq.failed": "Impossible d'envoyer cela",
  "fb.context": "Envoyez la page et l'appareil sur lequel je suis",
  "fb.contextOn": "Nous aide à le reproduire : {path}, plus la taille de l'écran, la langue et le navigateur. Pas de cookies ni de données personnelles.",
  "fb.contextOff": "Nous ne recevrons que votre message.",
  "pn.title": "Verrouillez votre boutique sur cet appareil",
  "pn.body": "Vos offres sont en ligne. Ajoutez un code d'accès et seule votre visage, empreinte digitale ou code PIN de l'appareil peut entrer dans cette boutique — pas de mot de passe à deviner ou à voler.",
  "pn.add": "Ajouter un code d'accès",
  "pn.notNow": "Pas maintenant",
  "tm.sortingAround": "Tri des offres autour de {place}.",
  "tm.cancel": "Annuler",
  "tm.nearPlace": "près de {place}",
  "tm.you": "vous",
  "tm.changeBase": "changer de base",
  "tm.yourBases": "Vos bases :",
  "tm.switchedTo": "Passé à {label}",
  "pw.placeholder": "Mot de passe",
  "pw.show": "Afficher le mot de passe",
  "pw.hide": "Cacher le mot de passe",
  "pw.veryWeak": "Trop faible",
  "pw.weak": "Faible",
  "pw.fair": "Ça s'améliore",
  "pw.strong": "Fort",
  "pw.veryStrong": "Très fort",
  "pw.crackTime": "prendrait {time} à craquer",
  "pw.needsWork": "Pas encore assez solide",
  "prc.bestValue": "MEILLEURE VALEUR",
  "qa.profanity": "Veuillez d'abord retirer les jurons — nous avons trouvé {words}. LytePress est lu par des familles et du personnel de magasin, donc les offres et les avis restent propres.",
  "sl.customTitle": "Choisissez votre propre lien",
  "sl.customPlus": "Inclus avec Elite — choisissez les mots après /s/ vous-même.",
  "sl.customOwned": "Vous possédez cet add-on — changez les mots après /s/ quand vous le souhaitez.",
  "sl.customOffer": "Votre lien est construit à partir du nom de votre entreprise. Vous voulez d'autres mots après /s/? C'est {price} une fois, à vous pour toujours — ou gratuit avec Elite.",
  "sl.customBuy": "Nommez mon lien — {price}",
  "sl.customEdit": "Modifier mon lien",
  "sl.customSave": "Enregistrer le lien",
  "sl.customCancel": "Annuler",
  "sl.customPlaceholder": "votre-nom-de-boutique",
  "sl.customSaved": "Votre nouveau lien est actif",
  "adn.linkTitle": "Choisissez votre propre lien de boutique",
  "adn.linkBody": "Choisissez les mots après /s/ vous-même au lieu d'utiliser le nom de votre entreprise — plus court à dire à voix haute, plus facile à coller. À vous pour toujours, un paiement.",
  "adn.linkCta": "Nommez mon lien — {price}",
  "adn.linkIncluded": "Inclus avec Elite",
  "adn.linkSetIt": "Définir mon lien",
  "adn.linkNeedsVerify": "Les liens de boutique nécessitent une vérification — envoyez d'abord vos documents.",
  "rst.thisResetLinkIs": "Ce lien de réinitialisation est invalide, déjà utilisé ou expiré. Veuillez en demander un nouveau à",
  "rst.minChars": "Utilisez au moins {n} caractères pour ce compte.",
  "acc.tabDeals": "Mes offres",
  "acc.tabShop": "Ma boutique",
  "acc.tabRedeem": "Échanger",
  "acc.tabAccount": "Compte",
  "sec.title": "Détails de connexion",
  "sec.sub": "Changez le mot de passe ou l'email avec lequel vous vous connectez.",
  "sec.pwTitle": "Mot de passe",
  "sec.pwNote": "Le changement vous déconnecte de tous les autres appareils.",
  "sec.pwCta": "Changer le mot de passe",
  "sec.currentPw": "Mot de passe actuel",
  "sec.newPw": "Nouveau mot de passe",
  "sec.pwSave": "Enregistrer le mot de passe",
  "sec.pwChanged": "Mot de passe changé",
  "sec.pwChangedNote": "Tous les autres appareils ont été déconnectés.",
  "sec.emailTitle": "Email de connexion",
  "sec.emailCta": "Changer l'email",
  "sec.newEmail": "Nouvelle adresse email",
  "sec.emailSave": "Envoyer la confirmation",
  "sec.emailConfirmNote": "Nous enverrons un lien à la nouvelle adresse. Rien ne change tant que vous ne cliquez pas dessus.",
  "sec.emailSent": "Vérifiez votre nouvelle boîte de réception",
  "sec.emailSentNote": "Nous avons envoyé un lien de confirmation à {email}. Il est valable pendant 24 heures.",
  "sec.emailPending": "En attente de la confirmation de {email}.",
  "ses.title": "Appareils connectés",
  "ses.sub": "Déconnectez tout ce que vous ne reconnaissez pas.",
  "ses.idleNote": "Déconnecté automatiquement après {n} heures d'inactivité.",
  "ses.thisDevice": "Cet appareil",
  "ses.signOutAll": "Déconnecter partout",
  "ses.signOutDevice": "Déconnecter cet appareil",
  "ses.signedOutDevice": "Cet appareil a été déconnecté",
  "ses.signedOutAll": "Déconnecté partout",
  "ses.signedOutAllNote": "Tous les autres appareils devront se reconnecter.",
  "ses.empty": "Aucun autre appareil n'est connecté.",
  "auth.endedIdle": "Vous avez été déconnecté après une période d'inactivité. Connectez-vous pour reprendre là où vous vous êtes arrêté.",
  "auth.endedRevoked": "Cet appareil a été déconnecté. Connectez-vous à nouveau pour continuer.",
  "pd.maxDays": "Votre plan propose une offre pendant jusqu'à {n} jours. Renouvelez-la d'un simple tapotement lorsqu'elle se termine.",
  "acc.renew": "Renouveler",
  "acc.renewTitle": "Remettez cette offre sur la carte avec un nouveau compte à rebours",
  "acc.renewDone": "Compte à rebours réinitialisé",
  "acc.renewRelisted": "De retour sur la carte",
  "acc.renewNote": "Cette offre dure encore {n} jours.",
  "pd.clampedTitle": "Date de fin avancée",
  "pd.clampedNote": "Votre plan propose une offre pendant jusqu'à {n} jours, c'est donc là que celle-ci se termine. Renouvelez-la d'un simple geste pour la continuer.",
  "nd.title": "Pas d'offres ici pour l'instant",
  "nd.sub": "Dites-nous où vous êtes et nous irons chercher des magasins sur la carte près de chez vous. C'est ainsi que nous décidons où frapper ensuite.",
  "nd.townPlaceholder": "Votre ville, par ex. Arima",
  "nd.emailPlaceholder": "Email (optionnel — nous vous informerons quand des offres arrivent)",
  "nd.cta": "Je veux des offres ici",
  "nd.thanks": "Noté",
  "nd.thanksNote": "Nous avons ajouté {place} à la liste.",
  "nd.onTheList": "Vous êtes sur la liste",
  "nd.onTheListNote": "Nous vous enverrons un email dès que des magasins près de chez vous commenceront à publier.",
  "map.shareNear": "Partager les offres les plus proches",
  "map.shareNearMsg": "Offres près de {place} en ce moment sur LytePress :",
  "promo.title": "\"Nous sommes sur LytePress\" graphique",
  "promo.sub": "Une image carrée avec votre code QR — postez-la sur Instagram, Facebook ou votre statut WhatsApp.",
  "promo.cta": "Télécharger l'image",
  "promo.saved": "Image enregistrée",
  "promo.savedNote": "Postez-la et quiconque qui scanne arrive directement sur vos offres.",
  "acc.weeklyRoundup": "Résumé hebdomadaire",
  "acc.dealsNearYouWeekly": "Offres près de chez vous, une fois par semaine",
  "acc.fiveClosestDeals": "Les cinq offres en direct les plus proches, envoyées par email une fois par semaine. Pas plus que ça.",
  "acc.digestOn": "Résumé hebdomadaire activé",
  "acc.digestOff": "Résumé hebdomadaire désactivé",
  "acc.digestOnNote": "Nous vous enverrons les offres les plus proches une fois par semaine.",
  "acc.digestOffNote": "Plus d'emails hebdomadaires. Les emails de compte continuent d'être envoyés.",
  "cat.Travel & Tours": "Voyages & Tours",
  "sr.watchAnother": "Regardez une autre catégorie :",
  "sr.pickCategory": "Choisissez une catégorie",
  "prc.startFree": "Commencez gratuitement — pas de carte requise",
  "prc.switchAtTermEnd": "Passez à {plan} lorsque ma période se termine",
  "prc.noProration": "Pas de prorata — votre période actuelle est déjà payée, donc le changement attend la fin.",
  "prc.cancelScheduled": "Annuler le changement prévu",
  "prc.scheduled": "Prévu : {plan}",
  "prc.scheduledOn": "Cela prend effet le {date}. Rien ne change avant.",
  "prc.scheduleCancelled": "Changement prévu annulé — rien ne change.",
  "prc.scheduledBanner": "Vous passez à {plan} le {date}. Tout ce que vous avez payé reste actif jusqu'à cette date.",
  "del.title": "Supprimer mon compte",
  "del.subShopper": "Supprime votre compte, les codes enregistrés, les favoris et les sessions. Les avis que vous avez laissés restent sur la boutique en tant que « Utilisateur supprimé ».",
  "del.subBusiness": "Vous pouvez supprimer votre compte une fois que vous n'avez plus d'offres actives ou programmées et qu'aucun abonnement payant n'est encore en cours. Tout sera alors supprimé : votre boutique, vos offres, vos photos et vos épingles.",
  "del.cta": "Supprimer mon compte",
  "del.warning": "C'est permanent. Nous ne pouvons pas récupérer le compte, vos offres ou vos photos.",
  "del.passwordPlaceholder": "Votre mot de passe",
  "del.typeDelete": "Tapez DELETE pour confirmer",
  "del.confirmCta": "Supprimer définitivement",
  "del.keepAccount": "Garder mon compte",
  "del.done": "Compte supprimé",
  "del.doneNote": "Tout a été supprimé. Merci d'avoir essayé LytePress.",
  "lg.deletingYourAccount": "7. Suppression de votre compte",
  "lg.deleteShopper": "Les acheteurs peuvent supprimer leur compte à tout moment depuis Mon Compte. Cela supprime le compte, les codes enregistrés, les favoris et les sessions actives. Les avis que vous avez écrits restent sur le profil de la boutique, affichés comme « Utilisateur supprimé », car la note d'une boutique est aussi une information pour les autres acheteurs.",
  "lg.deleteBusiness": "Les entreprises ne peuvent supprimer un compte que lorsqu'il n'y a plus d'offres actives ou programmées, et qu'aucun abonnement payant n'est encore en cours. Cela protège les acheteurs de trouver des épingles sur la carte pour une boutique qui n'existe plus, et vous protège de perdre du temps que vous avez déjà payé : supprimez ou laissez vos offres expirer, annulez le renouvellement, et supprimez une fois la période terminée. Écrivez-nous si vous devez partir plus tôt.",
  "lg.deleteAdmin": "Nous pouvons fermer un compte nous-mêmes — par exemple pour des violations répétées des politiques ou de la fraude — y compris un compte avec des offres actives. Nous vous enverrons un e-mail avec la raison lorsque cela se produira.",
  "msg.title": "Messages",
  "msg.sub": "Tout ce que nous vous envoyons arrive ici — répondez dans l'application et cela nous parvient directement.",
  "msg.new": "nouveau",
  "msg.noSubject": "Message",
  "msg.you": "Vous",
  "msg.replyPlaceholder": "Écrivez votre réponse…",
  "msg.send": "Envoyer la réponse",
  "msg.sent": "Réponse envoyée — nous reviendrons vers vous.",
  "prc.b5": "Votre propre lien de boutique, lytepress.com/s/votre-nom (boutiques vérifiées)",
  "sec.nudgeTitle": "Verrouillez votre boutique avec une clé d'accès",
  "sec.nudgeBody": "Votre compte contient vos offres, vos prix et votre historique de paiements. Une clé d'accès (Face ID ou empreinte digitale) ou un code à deux étapes rend un mot de passe volé inutile.",
  "sec.nudgePasskey": "Ajouter une clé d'accès",
  "sec.nudge2fa": "Activer la double authentification",
  "st.mission": "Notre mission est simple : aider les gens à dépenser moins pour les choses qu'ils achètent déjà, aider les boutiques locales à remplir les heures creuses, et gaspiller moins de nourriture et de stock en cours de route.",
  "an.lockedTitle": "Les insights Pro sont verrouillés",
  "an.lockedCta": "Découvrez ce que Pro ajoute",
  "af.footerLink": "Analytique",
  "af.badge": "Analyse des boutiques",
  "af.title": "Ce que vos analyses vous montrent",
  "af.subtitle": "Chaque boutique obtient les chiffres principaux. Pro et Elite ajoutent la couche de coaching — tendances, timing et repères.",
  "af.colMetric": "Ce que vous voyez",
  "af.colFree": "Gratuit",
  "af.colPaid": "Pro & Elite",
  "af.rowTotals": "Offres en cours, expirées et proches de l'expiration",
  "af.rowTraffic": "Total des vues, saisies, partages et abonnés",
  "af.rowDiscount": "Remise moyenne et taux de conversion",
  "af.rowCategory": "Vues réparties par catégorie",
  "af.rowTopDeals": "Votre classement des meilleures offres",
  "af.rowFunnel": "Entonnoir : vues à saisies à échangées",
  "af.rowRedemptions": "Total des échanges et directions prises",
  "af.rowGoal": "Suivi des objectifs d'échange mensuels",
  "af.rowTrends": "Tendances des vues, partages et abonnés au fil du temps",
  "af.rowBestTime": "Meilleur moment et meilleur jour pour publier",
  "af.rowWoW": "Mouvement semaine après semaine",
  "af.rowBenchmark": "Comment vos remises se comparent aux boutiques voisines",
  "af.rowRedemptionDetail": "Détails des échanges pour chaque offre",
  "af.rowMostShared": "Classement des plus partagés",
  "af.note": "Pro et Elite voient exactement les mêmes analyses — rien n'est caché pour le plan supérieur. Sur Gratuit, les lignes verrouillées apparaissent toujours, floues, afin que vous sachiez ce qui est là.",
  "af.seePlans": "Voir les plans et les prix",
  "af.openMine": "Ouvrir mes analyses",
  "af.compareLink": "Voir quelles analyses chaque plan vous offre",
  "an2.doNext": "Faites cela ensuite",
  "an2.tipNearExpiry": "{n} offre(s) expirent dans 48 heures — prolongez-les ou affinez le prix avant qu'elles ne tombent",
  "an2.tipDiscount": "Vos réductions sont environ {gap}% en dessous des magasins voisins dans votre catégorie — essayez {target}% sur votre prochaine offre",
  "an2.tipBestTime": "Vos acheteurs regardent autour de {time} le {day} — publiez votre prochaine offre juste avant cela",
  "an2.tipRedeem": "Seulement {rate}% des codes récupérés sont utilisés en magasin — un rappel ou une date limite comble cet écart",
  "an2.tipViewsDown": "Les vues sont en baisse de {n}% par rapport à la semaine dernière — une nouvelle offre les remonte plus vite que tout",
  "an2.tipGrabRate": "Seulement {rate}% des spectateurs saisissent vos offres — un prix plus attractif ou une photo plus claire résout généralement cela",
  "an2.tipShares": "Personne n'a encore partagé vos offres — envoyez le lien de votre magasin à vos propres clients une fois et regardez ce que cela fait",
  "an2.tipAllGood": "Rien n'a besoin d'être corrigé aujourd'hui — vos chiffres sont sains. Publiez quelque chose de frais pour les garder ainsi",
  "an2.proMore": "Pro s'occupe du reste pour vous",
  "an2.grabs": "Codes récupérés",
  "an2.subVsLastWeek": "{n}% par rapport à la semaine dernière",
  "an2.subOfViews": "{n}% des spectateurs saisissent",
  "an2.subOfGrabs": "{n}% de ceux échangés",
  "an2.subExpired": "{n} expiré",
  "an2.trend": "Tendance",
  "an2.mViews": "Vues",
  "an2.mRedemptions": "Échanges",
  "an2.mShares": "Partages",
  "an2.mFollowers": "Abonnés",
  "an2.noTrendData": "Rien ici encore pour celui-ci.",
  "an2.followersChip": "{n} abonnés",
  "an2.dealTable": "Comment chaque offre se porte",
  "an2.colDeal": "Offre",
  "an2.colViews": "Vues",
  "an2.colGrabs": "Récupérations",
  "an2.colRedeemed": "Échangés",
  "an2.colRate": "Taux",
  "an2.colShares": "Partages",
  "an2.tableNote": "Le taux est le nombre de codes échangés sur les codes récupérés. Un taux élevé signifie que l'offre convertit réellement — répétez-la ou boostez-la.",
  "an2.tipNearExpiryOne": "Une offre expire dans 48 heures — prolongez-la ou affinez le prix avant qu'elle ne soit périmée",
  "an2.tableNoteFree": "Pro ajoute des échanges, un taux d'échange et des partages pour chaque offre dans ce tableau.",
  "af.rowActions": "« Faites cela ensuite » — les améliorations à apporter, selon vos propres chiffres",
  "af.onePick": "1 sur 3",
  "af.rowDealTable": "Une table : chaque offre avec vues et saisies",
  "af.rowCompetition": "Concurrents à proximité et leurs réductions, côte à côte",
  "pd2.moreOptions": "Plus d'options",
  "pd2.moreHint": "Ceci reste tel que vous l'avez laissé la dernière fois, donc la plupart des offres n'ont besoin que d'une photo, d'un titre et d'un prix.",
  "pd2.codesOn": "codes activés",
  "pd2.featuredOn": "en vedette",
  "pd2.endToday": "Aujourd'hui",
  "pd2.end3": "3 jours",
  "pd2.end7": "7 jours",
  "pd2.end14": "14 jours",
  "pd2.endPick": "Choisissez une date",
  "pd2.endsAt": "Se termine le {date} à {time} ({gmt})",
  "pd2.exactTime": "Heure de fin exacte",
  "pd2.addSpot": "Épingler un autre endroit",
  "pd2.descHint": "Les acheteurs décident à partir de cela. {n} caractères supplémentaires nécessaires.",
  "pd2.descOk": "Les acheteurs décident à partir de celui-ci — bonne longueur.",
  "pd2.writeForMe": "Écris-le pour moi",
  "pd2.undoDraft": "Annuler",
  "pd2.draftFailed": "Impossible d'écrire un brouillon pour le moment",
  "pd2.photoFirst": "Ajoutez une photo d'abord et le brouillon décrira ce qu'il y a réellement dedans.",
  "pd2.draftNoPhoto": "Écrit uniquement à partir du titre — ajoutez une photo pour un brouillon plus précis.",
  "pc.yourPlan": "plan {plan}",
  "pc.freeForever": "Gratuit, aussi longtemps que vous le souhaitez.",
  "pc.lifetime": "À vous pour la vie — pas de renouvellement.",
  "pc.renews": "Se renouvelle le {date}",
  "pc.autoRenewsOn": "Renouvellement automatique le {date}",
  "pc.autoRenewOff": "Renouvellement automatique désactivé — le plan se termine le {date}",
  "pc.cancelAutoRenew": "Désactiver le renouvellement automatique",
  "pc.resumeAutoRenew": "Réactiver le renouvellement automatique",
  "pc.updateCard": "Mettre à jour la carte",
  "pc.renewNow": "Renouveler maintenant",
  "pc.graceMsg": "Renouvelez maintenant — votre forfait a expiré ; les avantages prennent fin dans {n} jours.",
  "pc.billingFail": "Impossible d'ouvrir le portail de facturation. Veuillez réessayer.",
  "pc.renewOffToast": "Renouvellement automatique désactivé — votre plan continue jusqu'à sa date de fin",
  "pc.renewOnToast": "Renouvellement automatique réactivé",
  "pc.renewFail": "Impossible de mettre à jour le renouvellement automatique. Réessayez.",
  "pc.buyDeals": "Acheter des offres supplémentaires",
  "bh.title": "Historique de facturation",
  "bh.subtitle": "Chaque paiement, avec un code de reçu que vous pouvez nous citer pour vérifier un achat.",
  "bh.loading": "Chargement de vos reçus…",
  "bh.empty": "Aucun paiement pour le moment.",
  "bh.invoice": "Facture",
  "bh.paid": "payé",
  "bh.pending": "non finalisé",
  "bh.refunded": "remboursé",
  "pc.upgrade": "Améliorer",
  "pc.nOfMThisMonth": "{n} sur {m} offres publiées ce mois-ci",
  "pc.unlimitedThisMonth": "Offres illimitées ce mois-ci",
  "pc.nLeft": "{n} restantes",
  "pc.noneLeft": "Aucune restante ce mois-ci",
  "pc.resets": "Votre quota se réinitialise le {date}",
  "pc.creditsHeld": "Offres supplémentaires en attente",
  "pc.nCreditsHeld": "{n} offres supplémentaires en attente",
  "pc.locations": "Emplacements épinglés",
  "pc.nBought": "{n} achetées",
  "pc.maxDays": "Jours pendant lesquels une offre peut être active",
  "pc.creditNote": "Les offres supplémentaires ne sont utilisées qu'une fois votre quota mensuel épuisé, et elles n'expirent jamais.",
  "tu.title": "Besoin de plus d'offres ce mois-ci ?",
  "tu.sub": "Les offres supplémentaires n'expirent jamais et ne sont utilisées qu'une fois votre quota mensuel épuisé.",
  "tu.youHold": "Vous en détenez {n} en ce moment.",
  "tu.each": "{price} chacune",
  "tu.perMonth": "/ 30 jours",
  "tu.buy": "Acheter",
  "tu.locationsTitle": "Emplacements supplémentaires sur la carte",
  "pc.rolledOver": "Reporté du mois dernier",
  "pc.rollsOverNote": "Les offres non utilisées se reportent au mois suivant, jusqu'à {cap}.",
  "pc.noRollover": "Réinitialisations gratuites le 1er — les plans payants reportent les offres non utilisées.",
  "pc.boughtNote": "Acheté ou offert. N'expirent jamais, même avec le plan Gratuit.",
  "pc.maxDaysShort": "Une offre peut durer jusqu'à {n} jours",
  "prc.f1": "4 offres par mois, se réinitialise le 1er, jusqu'à 14 jours chacune",
  "prc.p1": "30 offres par mois — celles non utilisées se reportent, jusqu'à 30 jours chacune",
  "prc.b1": "150 offres par mois — celles non utilisées se reportent, jusqu'à 60 jours chacune",
  "prc.b2": "25 emplacements épinglés, et vous pouvez en acheter d'autres",
  "pd2.titleSuggested": "Titre suggéré :",
  "pd2.useTitle": "Utiliser",
  "pd2.dismissTitle": "Garder le mien",
  "pd2.undoTitleChange": "Annuler le titre",
  "pw.placeholder8": "Mot de passe (au moins 8 caractères)",
  "pw.placeholder12": "Mot de passe (au moins 12 caractères)",
  "prc.rollFree": "Se réinitialise le 1er. Les offres gratuites ne s'accumulent pas.",
  "prc.rollPro": "Les offres non utilisées s'accumulent pendant un mois, jusqu'à 30 — donc un mois calme peut vous laisser 60 à publier le mois prochain.",
  "prc.rollPlus": "Les offres non utilisées s'accumulent pendant un mois, jusqu'à 150 — donc un mois calme peut vous laisser 300 à publier le mois prochain.",
  "prc.rollAddon": "Les offres supplémentaires achetées en tant qu'options ne expirent jamais.",
  "prc.rolledIn": "{n} reporté du mois dernier",
  "acc.emailFreqIntro": "À quelle fréquence devrions-nous vous envoyer des e-mails concernant les offres et promotions ?",
  "acc.freq_instant": "Dès que cela arrive",
  "acc.freq_instant_note": "Un e-mail par offre, limité à un par jour pour ne jamais vous submerger.",
  "acc.freq_daily": "Une fois par jour",
  "acc.freq_daily_note": "Tout ce qui se passe dans la journée regroupé dans un e-mail. Recommandé.",
  "acc.freq_weekly": "Une fois par semaine",
  "acc.freq_weekly_note": "Un récapitulatif par semaine, rien entre les deux.",
  "acc.freq_off": "Pas d'e-mail marketing",
  "acc.freq_off_note": "Rien de promotionnel. Vous verrez toujours tout dans l'application.",
  "acc.emailFreqSaved": "Fréquence d'e-mail enregistrée",
  "acc.emailCapNote": "Quelle que soit votre sélection, nous n'envoyons jamais plus d'un e-mail marketing par jour ou trois par semaine.",
  "an3.withinRadius": "Concurrents à l'intérieur de",
  "an3.anywhere": "Partout",
  "an3.radiusSummary": "{n} {cat} magasins avec des offres en cours dans un rayon de {km} km de votre épingle.",
  "an3.radiusSummaryAny": "{n} {cat} magasins avec des offres en cours, les plus proches en premier.",
  "an3.noneInRadius": "Aucun autre magasin {cat} n'a d'offre dans un rayon de {km} km de vous — cet espace est à vous.",
  "an3.noneAnywhere": "Aucun autre magasin {cat} n'a d'offre en cours en ce moment — cet espace est à vous.",
  "an3.radiusLocked": "Les concurrents à proximité par distance sont une fonctionnalité Pro.",
  "an3.radiusNoPin": "Épinglez votre magasin sur la carte et nous pourrons mesurer les magasins autour de vous.",
  "an3.pinMyShop": "Épinglez mon magasin",
  "pw.acceptWeak": "Je comprends que ce mot de passe est faible et je veux l'utiliser quand même",
  "pw.suggest": "Proposez-moi un mot de passe",
  "pw.memorable": "Facile à retenir",
  "pw.random": "Aléatoire",
  "pw.words": "Mots :",
  "pw.reroll": "Nouvelle suggestion",
  "pw.copy": "Copier",
  "pw.suggestNote": "Utilisez-le puis conservez-le en lieu sûr. Il respecte déjà nos règles de sécurité.",
  "auth.staffPortal": "Portail du personnel",
  "auth.staffSignIn": "Connexion du personnel",
  "auth.staffPortalNote": "Connectez-vous avec votre compte administrateur.",
  "pw.floorNote": "Chaque mot de passe doit comporter au moins 8 caractères, une lettre majuscule et un symbole.",
  "tu.credits_5.label": "5 offres supplémentaires",
  "tu.credits_5.note": "Cinq offres supplémentaires en plus de votre quota mensuel. Elles n'expirent jamais.",
  "tu.credits_20.label": "20 offres supplémentaires",
  "tu.credits_20.note": "Vingt offres supplémentaires à 75c chacune au lieu de 1 $. Elles n'expirent jamais.",
  "tu.credits_50.label": "50 offres supplémentaires",
  "tu.credits_50.note": "Cinquante offres supplémentaires à 60c chacune — le moyen le moins cher de publier beaucoup. Elles n'expirent jamais.",
  "tu.branch_1_30d.label": "1 emplacement supplémentaire",
  "tu.branch_1_30d.note": "Épinglez un emplacement de plus pendant 30 jours. Achetez-le à nouveau pour le garder.",
  "tu.branch_5_30d.label": "5 emplacements supplémentaires",
  "tu.branch_5_30d.note": "Épinglez cinq emplacements de plus pendant 30 jours. Achetez-les à nouveau pour les garder.",
  "acc.quietTitle": "Heures calmes",
  "acc.quietNote": "Rien de promotionnel n'arrive pendant la nuit — cela attend le matin.",
  "acc.quietFrom": "Calme de",
  "acc.quietTo": "jusqu'à",
  "acc.quietYourTime": "votre heure locale",
  "acc.quietSaved": "Heures calmes enregistrées",
  "pw.leaked": "Vu dans {n} violations de données connues — les attaquants essaient d'abord ceux-ci.",
  "auth.backToLogin": "Retour à la connexion",
  "auth.demoLabel": "Démo :",
  "acc.nextEmailAt": "Prochain email : {when}",
  "acc.nextEmailOff": "Nous ne vous enverrons rien de promotionnel.",
  "acc.nextEmailSoon": "dans un instant",
  "acc.nextEmailToday": "aujourd'hui après {time}",
  "acc.nextEmailTomorrow": "demain après {time}",
  "acc.nextEmailWaiting": "{n} en attente d'être regroupés",
  "an3.myCategory": "ma catégorie",
  "lg.asIsTitle": "Service fourni tel quel",
  "lg.asIsBody": "LytePress est une plateforme en évolution, et bien que nous nous efforçons de fournir une expérience fiable et fluide, des erreurs ou des temps d'arrêt peuvent survenir. En utilisant LytePress, vous reconnaissez que vous le faites à votre propre discrétion et à vos risques. Nous ne pouvons garantir un service ininterrompu ni accepter la responsabilité des pertes résultant de l'utilisation de la plateforme. Si vous rencontrez des erreurs ou des problèmes, nous vous encourageons à nous en informer afin que nous puissions les résoudre le plus rapidement possible. Nous apprécions votre compréhension et votre soutien alors que nous continuons à améliorer LytePress.",
  "lg.asIsShort": "LytePress est encore en croissance et en changement. Il est fourni tel quel — vous l'utilisez à votre propre discrétion et à vos risques, et si quelque chose ne fonctionne pas, veuillez nous le dire afin que nous puissions le réparer.",
  "lg.passwordRules": "Chaque mot de passe doit comporter au moins 8 caractères, une lettre majuscule et un symbole, et ne peut pas contenir votre propre nom, le nom de la boutique ou votre email. Les comptes de boutique et d'administrateur doivent avoir 12 caractères. Nous vérifions les nouveaux mots de passe par rapport à des listes publiques de mots de passe divulgués : un compte de boutique ou d'administrateur ne peut pas utiliser un mot de passe qui apparaît dans une fuite, et un acheteur qui choisit un mot de passe faible ou divulgué doit confirmer qu'il accepte le risque.",
  "lg.quotaTerms": "Les plans payants incluent un nombre mensuel de promotions que vous pouvez publier (un quota), sans garantie de vues, de clics ou de ventes. Les promotions non utilisées sur un plan payant se reportent pour un mois seulement, plafonnées à un mois. Les promotions achetées en tant qu'options supplémentaires n'expirent pas. Un quota est un plafond d'utilisation équitable et nous pouvons ajuster les plafonds avec préavis.",
  "lg.aiHelp": "Copie d'offre assistée par IA",
  "lg.aiHelpBody": "Nous proposons un outil optionnel qui rédige un titre et une description d'offre à partir des détails et de la photo que vous fournissez. Le brouillon est une suggestion uniquement : vous choisissez de l'utiliser, vous pouvez l'éditer ou l'annuler, et vous restez responsable de tout ce qui est publié sur votre offre, y compris l'exactitude, les revendications et la conformité légale. Votre prompt et la première photo sont envoyés à notre fournisseur d'IA pour produire le brouillon. Nous limitons le nombre de brouillons que chaque boutique peut demander par jour et pouvons désactiver l'outil à tout moment.",
  "lg.emailsWeSend": "Emails que nous envoyons",
  "lg.emailsWeSendBody": "Les emails de compte, de sécurité, de paiement et de modération font partie du service et sont toujours envoyés. Les emails promotionnels — alertes de nouvelles offres, récapitulatifs et promotions — sont limités à un email par jour et trois par semaine par compte, et vous choisissez à quelle fréquence vous souhaitez avoir de nos nouvelles (au fur et à mesure, quotidiennement, hebdomadairement ou pas du tout) ainsi que des heures de silence pendant lesquelles rien de promotionnel n'est envoyé. Chaque email promotionnel contient un lien de désinscription, et nous envoyons dans la langue que vous utilisez sur le site où nous avons ce libellé.",
  "lg.quotasAndCredits": "5. Quotas mensuels et offres supplémentaires",
  "lg.quotasAndCreditsBody": "Le quota mensuel d'offres d'un plan se réinitialise le 1er. Sur les plans payants, les offres non utilisées se reportent pour un mois seulement, plafonnées à un mois, et elles n'ont aucune valeur monétaire — un quota non utilisé n'est pas remboursable et ne peut pas être transféré entre les comptes. Les offres supplémentaires ou les emplacements achetés en tant qu'options ne sont pas remboursables une fois qu'une partie a été utilisée ; si aucune n'a été utilisée, demandez-nous dans les 14 jours et nous vous rembourserons.",
  "lg.collectLangEmail": "Nous stockons également la langue dans laquelle vous lisez le site (afin que nos emails correspondent), votre fréquence d'email et vos paramètres d'heures de silence, ainsi qu'un enregistrement des emails promotionnels que nous vous avons envoyés afin de respecter les plafonds quotidiens et hebdomadaires.",
  "lg.sharingAi": "Lorsque vous utilisez l'outil optionnel de rédaction d'offres assisté par IA, le texte que vous avez saisi et la première photo de l'offre sont envoyés à notre fournisseur d'IA pour générer le brouillon. Nous ne leur envoyons pas votre nom, votre email ou vos détails de compte, et nous n'utilisons pas vos offres pour entraîner les modèles de qui que ce soit.",
  "lg.breachCheckPrivacy": "Lorsque vous définissez un mot de passe, nous le vérifions par rapport à des listes publiques de mots de passe divulgués en utilisant une méthode où seuls les cinq premiers caractères d'un hachage unidirectionnel quittent notre serveur — votre mot de passe, et le hachage complet, ne le font jamais. Si ce service n'est pas disponible, nous passons simplement la vérification.",
  "lg.privacyEmailChoices": "Vous contrôlez les emails promotionnels depuis Mon Compte : choisissez au fur et à mesure, quotidiennement, hebdomadairement ou aucun, définissez des heures de silence dans votre propre fuseau horaire, ou utilisez le lien de désinscription dans tout email promotionnel. Les emails de compte, de sécurité et de paiement ne peuvent pas être désactivés tant que votre compte est ouvert.",
  "acc.browseDealsArrow": "Parcourir les offres →",
  "acc.verifiedRedemptionsOnly": "Remboursements en magasin vérifiés uniquement.",
  "acc.approxIn": "environ dans {cur}",
  "an3.sameSpot": "Même endroit",
  "an3.underTenth": "moins de 0,2 km",
  "an3.kmAway": "{km} km",
  "an3.nearestOf": "le plus proche de {n} emplacements",
  "an3.rivalsHidden": "{n} magasins concurrents proposent des offres ici.",
  "an3.rivalsHiddenNote": "Pro et Elite vous montrent qui ils sont, à quelle distance ils se trouvent et à quel point ils font des réductions.",
  "an3.liveCount": "{n} en direct",
  "bo.fitShorter": "Votre offre se termine dans {days} jours, donc cela dure {days} au lieu de {full} — prix ajusté.",
  "bo.fitTooShort": "Cette offre se termine dans moins d'un jour. Renouvelez ou prolongez-la d'abord et la durée complète est à vous.",
  "an3.locationsCount": "{n} emplacements",
  "an3.locationN": "Emplacement {n}",
  "an3.legendYou": "Vous",
  "an3.legendRival": "Concurrent · remise moyenne %",
  "an3.compareRival": "Comparer avec mes offres",
  "auth.agreeCheckbox": "J'ai lu et j'accepte le",
  "lg.setOutBelow": "indiqué dans les sections de facturation ci-dessous",
  "acc.rivalAlertsTitle": "Préviens-moi quand un concurrent propose une meilleure offre",
  "acc.rivalAlertsNote": "Un avertissement par semaine, au maximum, lorsqu'un magasin à moins de 10 km dans ta catégorie publie une offre au moins 10 points plus avantageuse que ta moyenne actuelle. Pro et Elite uniquement.",
  "acc.rivalAlertsOn": "Les alertes de concurrents sont activées",
  "acc.rivalAlertsOff": "Les alertes de concurrents sont désactivées",
  "st.asWeExpandThroughout": "Alors que nous grandissons dans de nouvelles villes et marchés, notre objectif est de devenir la destination la plus fiable pour découvrir des offres locales, des promotions, des expériences et des opportunités.",
  "st.valSustainable": "Encourager la consommation durable dans chaque marché que nous desservons.",
  "st.lytepressIsAGrowing": "LytePress est une communauté en pleine croissance qui connecte les gens avec des entreprises locales, récompense les dépenses intelligentes, soutient l'entrepreneuriat et encourage la consommation durable.",
  "lg.contact2": "8. Contact",
  "lg.whoWeAre": "1. Qui nous sommes",
  "lg.informationWeCollect": "2. Informations que nous collectons",
  "lg.howWeUseIt": "3. Comment nous l'utilisons",
  "lg.location": "4. Localisation",
  "lg.sharing": "5. Partage",
  "lg.security": "6. Sécurité",
  "lg.yourChoices": "7. Vos choix",
  "lg.whoWeAreBody": "LytePress est le nom légal de l'entité qui gère cette plateforme, enregistrée à Trinidad et Tobago, et est le responsable des données pour les informations décrites ici. Nous servons des entreprises et des acheteurs dans le monde entier, donc vos informations peuvent être traitées dans d'autres pays par les fournisseurs listés sous Partage. Questions sur vos données : support@lytepress.com.",
  "lg.lawDisputesBody": "LytePress est le nom légal de l'entité qui exploite cette plateforme et est enregistrée à Trinité-et-Tobago, tandis que le service lui-même est disponible pour les entreprises et les acheteurs dans le monde entier — notre enregistrement n'est pas une limite à notre fonctionnement. Ces termes sont régis par les lois de Trinité-et-Tobago, et ses tribunaux ont compétence sur tout litige. Cela n'affecte pas vos droits en vertu de la loi sur la consommation du pays dans lequel vous vivez, et cela ne limite pas les pays que LytePress dessert. Parlez-nous d'abord à support@lytepress.com — presque tout est réglé plus rapidement de cette façon.",
  "lg.plainSummary": "LytePress (\"nous\") permet aux entreprises de publier leurs offres et aux acheteurs de trouver les bonnes affaires autour d'eux, où qu'ils commercent. Ces pages sont écrites en langage simple par intention, et si quelque chose ici n'est pas clair, vous pouvez envoyer un email à support@lytepress.com et une personne vous l'expliquera. En utilisant LytePress, vous acceptez les points ci-dessous.",
  "qa.firstDealPending": "Première offre — en cours de révision",
  "qa.firstDealPendingMsg": "Nous jetons un rapide coup d'œil à la première offre d'un nouveau magasin avant qu'elle n'apparaisse sur la carte. Elle est généralement mise en ligne dans quelques heures, et chaque offre après celle-ci est publiée immédiatement.",
  "rpt.notHonoured": "L'offre n'a pas été honorée",
  "rpt.notHonouredSent": "Rapport envoyé",
  "rpt.notHonouredThanks": "Merci de nous avoir informés",
  "rpt.notHonouredNote": "Cela va directement à notre équipe de modération et nous faisons un suivi avec le magasin.",
  "rpt.notHonouredHelp": "Vous êtes entré et le magasin a refusé cette offre ? Un simple tap nous le dit — pas de formulaire à remplir.",
  "ver.title": "Confirmez votre email pour publier des offres",
  "ver.note": "Nous avons envoyé un lien et un code à 6 chiffres à {email}. Les offres que vous publiez sont en attente jusqu'à ce que vous confirmiez — elles seront actives dès que vous le ferez.",
  "ver.codePlaceholder": "000000",
  "ver.confirmCode": "Confirmer",
  "ver.resend": "Renvoyer",
  "ver.sent": "Email en route",
  "ver.sentNote": "Vérifiez {email} — le lien et le code fonctionnent tous les deux.",
  "ver.couldNotSend": "Impossible d'envoyer cet email",
  "ver.badCode": "Ce code n'a pas fonctionné",
  "ver.done": "Email confirmé",
  "ver.doneNote": "Tout est prêt — tout ce que vous aviez en attente est maintenant actif.",
  "ver.checking": "Confirmation de votre email...",
  "ver.badLink": "Ce lien n'a pas fonctionné",
  "ver.badLinkNote": "Il a peut-être expiré ou a déjà été utilisé.",
  "ver.useCodeInstead": "Tapez le code à 6 chiffres de l'email dans la bannière de votre tableau de bord à la place.",
  "ver.noToken": "Ce lien est manquant son code.",
  "ver.goToAccount": "Aller à mon compte",
  "qa.emailPending": "Confirmez d'abord votre email",
  "qa.emailPendingMsg": "Votre offre est enregistrée et en attente. Appuyez sur le lien dans l'email que nous vous avons envoyé — ou tapez le code à 6 chiffres dans la bannière de votre tableau de bord — et elle sera active immédiatement.",
  "ver.enterCodeHere": "Tapez le code à 6 chiffres de l'e-mail ici",
  "ver.manualTitle": "Confirmez votre e-mail",
  "ver.manualNote": "Ouvrez l'e-mail que nous vous avons envoyé et tapez son code à 6 chiffres ci-dessous. Pas besoin d'être connecté.",
  "ver.needANewOne": "Vous avez perdu l'email ou le code a expiré ?",
  "ver.emailPlaceholder": "L'email avec lequel vous vous êtes inscrit",
  "ver.sendNewEmail": "Envoyer un nouvel email",
  "ver.emailSentShort": "Email envoyé",
  "vf.unlocks": "Jusqu'à ce que vous soyez vérifié, vous pouvez publier 2 offres à la fois depuis un seul emplacement, et le placement payant reste fermé. La vérification lève les trois.",
  "qa.liveCapTitle": "C'est votre limite d'offres en direct",
  "sr.passNeedsVerification": "Les Passes Boost s'ouvrent une fois que votre entreprise est vérifiée.",
  "ver.domainTip": "Astuce : confirmer une adresse sur votre propre domaine d'entreprise (pas Gmail ou Hotmail) lève immédiatement vos limites de deals en direct et de localisation.",
  "vf.domainTier": "Email de domaine confirmé",
  "vf.domainTierNote": "Vous avez confirmé un code envoyé à {domain}, une adresse sur votre propre domaine d'entreprise, donc vos limites de trading sont déjà levées. Le placement payant attend toujours vos documents.",
  "br.pinFarFromListing": "{branch} est épinglé à environ {distance} km de l'annonce Google que nous avons trouvée sous votre nom — {listing}, {address}. Si l'épingle est incorrecte, les acheteurs qui appuient sur Itinéraire sont envoyés ailleurs. Faites-la glisser sur votre porte et enregistrez.",
  "br.thisPin": "Cette épingle",
  "fx.title": "Déplacer cette épingle ?",
  "fx.summary": "{business} a épinglé {branch} à environ {distance} km de l'annonce Google que nous avons trouvée sous votre nom — {listing}{address}.",
  "fx.legend": "Le rouge indique où se trouve votre épingle actuellement. Le vert est l'annonce. Confirmer déplace l'épingle enregistrée et la même épingle sur vos offres en direct. Si votre épingle est correcte et que l'annonce appartient à quelqu'un d'autre, fermez simplement cette page — rien ne change.",
  "fx.confirm": "Oui, déplacez mon épingle ici",
  "fx.now": "Maintenant",
  "fx.listing": "Annonce",
  "fx.moved": "Épingle déplacée",
  "fx.movedNote": "{branch} se trouve maintenant à {address}. Vos offres en direct ont également été mises à jour, donc Directions enverra les acheteurs au bon endroit à partir de maintenant.",
  "fx.yourPin": "Votre épingle",
  "fx.yourListing": "votre annonce Google",
  "fx.aLocation": "un emplacement",
  "fx.expired": "Ce lien a expiré",
  "fx.expiredNote": "Les liens à un clic durent 14 jours. Vous pouvez toujours déplacer l'épingle vous-même depuis Mon Compte.",
  "fx.cantUse": "Nous ne pouvons pas utiliser ce lien",
  "fx.checking": "Vérification de ce lien…",
  "fx.noCode": "Ce lien manque de son code. Ouvrez à nouveau l'email.",
  "fx.invalid": "Ce lien n'est plus valide.",
  "fx.failed": "Impossible de déplacer cette épingle.",
  "fx.openAccount": "Ouvrir Mon Compte",
  "fx.byHand": "pour déplacer n'importe quelle épingle manuellement.",
  "pv.verifiedOn": "Prix vérifié {date}",
  "pv.checkFirst": "Vérifiez le prix avant d'y aller",
  "pv.changed": "Les acheteurs disent que ce prix a changé",
  "pv.tooltip": "La dernière fois que quelqu'un a soutenu ce prix.",
  "pv.countOne": "1 acheteur l'a confirmé",
  "pv.countMany": "{n} acheteurs l'ont confirmé",
  "pv.shopperHelp": "Vous y êtes allé récemment ? Dites aux autres si ce prix est toujours valable.",
  "pv.ownerHelp": "C'est toujours votre prix ? Un tap pour re-valider cette offre aujourd'hui.",
  "pv.signInHint": "Connectez-vous en tant qu'acheteur pour confirmer ce prix.",
  "pv.stillRight": "Le prix est toujours correct",
  "pv.priceChanged": "Prix changé",
  "pv.youConfirmed": "Vous avez confirmé ce prix.",
  "pv.youFlagged": "Vous nous avez dit que ce prix a changé.",
  "pv.thanksConfirmed": "Merci — prix vérifié",
  "pv.thanksConfirmedMsg": "Chaque acheteur qui voit cette offre sait maintenant que le prix est à jour.",
  "pv.thanksFlagged": "Merci pour l'alerte",
  "pv.thanksFlaggedMsg": "Nous demanderons au magasin de réaffirmer le prix.",
  "pv.couldNotSave": "Impossible de sauvegarder cela",
  "pv.wasItRight": "Le prix était-il juste ?",
  "pv.yesRight": "Oui, tout à fait",
  "pv.noChanged": "Non, il a changé",
  "footer.cities": "Villes",
  "cities.seoTitle": "Offres par ville",
  "cities.seoDesc": "Chaque ville avec des offres en direct sur LytePress, plus les endroits que nous allons ouvrir prochainement.",
  "cities.heading": "Offres par ville",
  "cities.subline": "Choisissez votre ville et voyez ce qui est disponible en ce moment. De nouvelles villes apparaissent ici dès que les magasins commencent à publier.",
  "cities.openingSoon": "Ouverture prochaine",
  "city.seoTitle": "Offres à {city}, {country}",
  "city.seoDescEmpty": "LytePress s'ouvre à {city}, {country}. Vous connaissez un magasin qui devrait être ici ? Invitez-les.",
  "city.heading": "Offres à {city}",
  "city.sublineEmpty": "Nous ouvrons à {city}, {country}. Pas encore d'offres ici.",
  "city.liveDeals": "{n} offres en direct",
  "city.shops": "{n} magasins",
  "city.onTheMap": "Voir sur la carte",
  "city.allCities": "Toutes les villes",
  "city.noPage": "Pas encore de page d'offres pour cette ville.",
  "city.emptyTitle": "Rien en direct à {city} pour l'instant",
  "city.emptyBody": "Nous ouvrons une ville dès qu'un magasin y publie. Si vous connaissez un endroit à {city} qui mérite une place sur la carte, envoyez-le nous — cela prend une minute et c'est gratuit.",
  "city.browseEverywhere": "Parcourir les offres partout",
  "city.aboutTitle": "À propos des offres à {city}",
  "city.aboutBody": "LytePress liste ce que les magasins locaux à {city}, {country} ont réduit en ce moment — principalement {cats}. Chaque offre montre le prix, ce qu'il était, combien de temps elle dure et exactement où aller.",
  "city.aboutTrust": "Les prix portent la date à laquelle ils ont été confirmés pour la dernière fois, et les acheteurs qui y sont allés peuvent dire aux autres si un prix est toujours valable. Rien ici n'est une supposition.",
  "city.everyCategory": "toute catégorie",
  "city.nearbyTitle": "Autres villes",
  "city.otherLanguages": "Lire ceci en",
  "city.seoDesc": "{deals} de {shops} à {city}, {country}. Prix confirmés par les acheteurs, mis à jour chaque jour.",
  "city.subline": "{deals} de {shops} dans {city}, {country} — avec des prix confirmés par les acheteurs.",
  "city.liveDealOne": "1 offre en direct",
  "city.shopOne": "1 magasin",
  "loc.following": "Suivi de votre emplacement",
  "loc.followingLive": "Vous suit au fur et à mesure de vos déplacements",
  "loc.notFollowing": "Emplacement épinglé ici",
  "loc.turnOff": "désactiver",
  "loc.turnOn": "me suivre à nouveau",
  "loc.goLive": "suivre pendant que je bouge",
  "loc.stopLive": "arrêter le suivi en direct",
  "loc.nearCity": "Vous êtes près de {city}",
  "loc.seeThoseDeals": "Voir ces offres",
  "pd.quietHours": "Offre d'heures calmes",
  "pd.quietHoursHint": "Une remise permanente qui se répète — comme de 15h à 17h en semaine, pour remplir le creux.",
  "pd.quietFrom": "De",
  "pd.quietTo": "Jusqu'à",
  "pd.quietNote": "Les acheteurs voient toujours l'offre en dehors de ces heures — elle s'affiche quand elle commence, et les codes ne fonctionnent que pendant la période.",
  "pd.mon": "Lun",
  "pd.tue": "Mar",
  "pd.wed": "Mer",
  "pd.thu": "Jeu",
  "pd.fri": "Ven",
  "pd.sat": "Sam",
  "pd.sun": "Dim",
  "time.am": "am",
  "time.pm": "pm",
  "qh.onUntil": "Jusqu'à {time}",
  "qh.starts": "Commence à {time}",
  "qh.runs": "Valide {days}, de {from} à {to}",
  "qh.weekdays": "jours de semaine",
  "qh.weekends": "week-ends",
  "qh.everyDay": "tous les jours",
  "pitch.print": "Imprimer les deux feuilles",
  "pitch.printHint": "Deux pages : cette ville, puis ce qu'est LytePress. Imprimer ou enregistrer en PDF.",
  "pitch.cityHeading": "{city} est déjà sur la carte.",
  "pitch.citySub": "Voici ce que les acheteurs à {city}, {country} voient lorsqu'ils ouvrent LytePress et cherchent quelque chose qui vaut le déplacement.",
  "pitch.statDeals": "Offres en direct",
  "pitch.statShops": "Magasins listés",
  "pitch.statTop": "Le plus listé",
  "pitch.mapTitle": "La carte aujourd'hui",
  "pitch.yourSpot": "Votre emplacement",
  "pitch.noMapKey": "Carte indisponible",
  "pitch.alreadyOn": "Déjà sur LytePress ici",
  "pitch.claimTitle": "Il y a un vide à {city}.",
  "pitch.claimBody": "Scannez pour revendiquer votre emplacement. L'inscription est gratuite, cela prend environ deux minutes, et votre première offre peut être en ligne aujourd'hui.",
  "pitch.qrCityPage": "Voir les offres à {city}",
  "pitch.qrClaim": "Revendiquer votre emplacement",
  "pitch.aboutHeading": "Ce qu'est LytePress.",
  "pitch.aboutLine": "Une carte d'offres réelles provenant de magasins réels. Les acheteurs l'ouvrent pour voir ce qui est en promotion près d'eux en ce moment — et chaque prix indique la date à laquelle quelqu'un l'a confirmé pour la dernière fois.",
  "pitch.mapCaption": "Chaque épingle est un magasin avec une offre en direct.",
  "pitch.forShoppers": "Pour les acheteurs",
  "pitch.shopper1": "Découvrez ce qui est en promotion à distance de marche, en ce moment, avec des directions jusqu'à la porte.",
  "pitch.shopper2": "Chaque prix indique quand il a été confirmé pour la dernière fois — par le magasin, ou par un acheteur qui était juste là.",
  "pitch.shopper3": "Aliments proches de la date d'expiration et stocks à courte durée de vie au même endroit, pour que la bonne nourriture soit consommée au lieu d'être jetée.",
  "pitch.forShops": "Pour les magasins",
  "pitch.shop1": "L'inscription est gratuite. Vous publiez une offre, elle apparaît sur la carte et sur la page de votre ville.",
  "pitch.shop2": "Écoulez les stocks proches de la date au lieu de les radier.",
  "pitch.shop3": "Remplissez vos heures calmes avec une remise permanente qui ne fonctionne que pendant la période que vous choisissez.",
  "pitch.howTitle": "Comment ça fonctionne",
  "pitch.how1": "Inscrivez-vous en tant que magasin et déposez une épingle là où vous êtes réellement.",
  "pitch.how2": "Publiez votre offre — une photo, le prix, et combien de temps elle dure.",
  "pitch.how3": "Les acheteurs à proximité la voient, entrent, et montrent un code que vous vérifiez au comptoir.",
  "pitch.startTitle": "Commencez avec une offre.",
  "pitch.startBody": "Scannez ceci, inscrivez-vous et mettez une offre sur la carte. Si personne ne vient, vous avez perdu deux minutes.",
  "pitch.qrStart": "Inscrivez votre magasin",
  "pitch.exampleTitle": "À quoi ressemble une semaine à {city}",
  "pitch.exampleTag": "Exemple",
  "pitch.demoNote": "Les épingles et les annonces ci-dessus sont des exemples — {city} est ouverte et attend ses premiers magasins.",
  "pitch.mapCaptionDemo": "Épingles d'exemple — voici à quoi ressemble une ville une fois que les magasins commencent à publier.",
  "pitch.cityHeadingDemo": "{city} est la prochaine sur la carte.",
  "pitch.citySubDemo": "LytePress s'ouvre à {city}, {country}. Voici ce que les acheteurs verront ici — et à quoi ressemblerait votre propre annonce.",
  "pitch.sellFreeN": "Gratuit",
  "pitch.sellFree": "Pour lister vos offres",
  "pitch.sellFastN": "2 min",
  "pitch.sellFast": "Pour inscrire votre magasin",
  "pitch.sellLiveN": "Aujourd'hui",
  "pitch.sellLive": "Votre première offre est en ligne",
  "pd.shortDatedHint": "Pour les produits proches de leur date de péremption - aliments, boissons, suppléments, médicaments, cosmétiques, huile moteur, batteries, graines, encre. Les acheteurs voient un badge à date courte ; être transparent permet de vendre plus vite et de réduire le gaspillage.",
  "pc.giftedNote": "Offert par nous. Les plus anciens sont dépensés en premier.",
  "pc.giftedHeld": "Extras offerts",
  "pc.giftedUseBy": "Utilisez {n} avant {date}",
  "lo.title": "Un merci de LytePress",
  "lo.credits": "{n} offres supplémentaires sont déjà sur votre compte.",
  "lo.neverExpires": "Elles n'expirent jamais.",
  "lo.useBy": "Utilisez-les avant {date}.",
  "lo.codeLine": "Et {off} de réduction sur {what} avec votre code.",
  "lo.codeValid": "Uniquement pour vous, une utilisation, jusqu'au {date}.",
  "lo.useIt": "Utilisez-le",
  "lo.seePlans": "Voir les plans",
  "lo.copy": "Copier le code",
  "lo.pkgPro": "Pro mensuel",
  "lo.pkgProYear": "Pro annuel",
  "lo.pkgElite": "Elite mensuel",
  "lo.pkgEliteYear": "Elite annuel",
  "lo.pendingTitle": "Une offre choisie pour votre boutique",
  "lo.pendingWhat": "Comprend {what}",
  "lo.pay": "Payer {price}",
  "lo.paying": "Ouverture du paiement…",
  "lo.invoiceMonthly": "{price} — facturé chaque mois, nous vous enverrons la facture.",
  "lo.payFailed": "Impossible d'ouvrir le paiement. Veuillez réessayer.",
  "lo.pkgPlan": "votre plan",
  "lo.titleSoon": "Il ne reste que {n} jours pour utiliser ceci",
  "vf.body": "Envoyez-nous vos documents d'entreprise et nous ajouterons un badge vérifié bleu à votre profil. Les acheteurs font plus confiance aux magasins vérifiés — et cela débloque chaque catégorie.",
  "vf.regPlaceholder": "Numéro d'enregistrement (facultatif)",
  "qa.needs_verification": "Les offres « {category} » ne peuvent être publiées que par une entreprise vérifiée. Faites-vous vérifier depuis Mon Compte — généralement en moins d'un jour.",
  "trust.verifiedBody": "Approuvé par notre équipe.",
  "trust.independentBody": "Pas encore approuvé — mais de nombreux excellents vendeurs locaux commencent ici. Leurs offres sont toujours vérifiées pour la qualité.",
  "browse.nothingWithin": "Rien à moins de {radius} pour l'instant",
  "browse.nothingWithinMsg": "Aucune offre active n'a de point à moins de {radius} de vous. Plutôt que de remplir la page de boutiques inaccessibles, voici la réponse honnête — et deux façons d'élargir la recherche.",
  "browse.showFurther": "Voir {n} offres plus loin",
  "browse.hideFurther": "Masquer les offres plus loin",
  "browse.furtherNote": "Elles sont au-delà de {radius} de vous, les plus proches d'abord.",
  "browse.browseCountry": "Parcourir tout le pays",
  "mt.title": "Nous revenons très vite",
  "mt.body": "LytePress fait l'objet d'une mise à jour programmée. Votre compte n'est pas affecté : offres, crédits et codes sont exactement là où vous les avez laissés.",
  "mt.backIn": "De retour dans",
  "mt.backAt": "Retour prévu à {time}",
  "mt.soon": "De retour d'un instant à l'autre.",
  "mt.staff": "Connexion équipe",
  "mt.readonly": "Maintenance programmée : vous pouvez consulter, mais la publication et les paiements sont en pause.",
  "mt.notice": "Maintenance programmée {when} — le site pourra être brièvement indisponible.",
  "mt.adminOn": "Le mode maintenance est ACTIF — tout le monde sauf les administrateurs est bloqué.",
  "prc.usdNote": "Facturé en dollars américains. Si votre carte est dans une autre devise, votre banque applique son propre taux : le montant sur votre relevé peut donc différer légèrement.",
  "prc.feeNote": "Votre banque peut ajouter des frais de conversion de devise ou de transaction.",
  "lg.availabilityTitle": "Disponibilité du service et maintenance programmée",
  "lg.availabilityBody": "LytePress est mis à jour régulièrement. Les mises à jour logicielles et la maintenance sont effectuées à intervalles, et l'accès au site, à l'application ou à votre tableau de bord peut être temporairement indisponible pendant ces travaux.\n\nLorsque les travaux sont planifiés et risquent d'interrompre le service, nous nous efforçons d'afficher un avis dans l'application à l'avance et de les programmer aux heures calmes. De courtes périodes d'indisponibilité, prévues ou non, font partie du fonctionnement normal d'un service en ligne et n'ouvrent pas à elles seules droit à un remboursement. Si un Boost ou un emplacement À la une payant n'a pas fonctionné à cause d'une panne de notre côté, nous créditons ou remboursons cet emplacement : écrivez à support@lytepress.com et nous corrigerons cela.",
  "lg.forceMajeureTitle": "Force majeure",
  "lg.forceMajeureBody": "Ni vous ni LytePress n'êtes responsables du non-respect d'une obligation de ces conditions lorsque la cause échappe à tout contrôle raisonnable. Cela inclut les tempêtes, ouragans, inondations, séismes, incendies, épidémies ou pandémies, guerre, troubles civils, grèves, actes ou ordres d'un gouvernement ou d'un régulateur, défaillance de l'électricité ou d'internet, ainsi que la défaillance ou la suspension d'un prestataire tiers dont nous dépendons (hébergement, paiement, cartographie ou e-mail).\n\nPendant la durée d'un tel événement, les obligations concernées sont suspendues et non rompues, et nous rétablirons le service normal dès que raisonnablement possible. Si un tel événement maintient le service hors ligne plus de 30 jours consécutifs, chacune des parties peut mettre fin à un abonnement payant et nous rembourserons la partie non utilisée de la période.",
};

export default fr;
